import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PasswordInput } from '../../components/ui/password-input';
import { useNavigate } from 'react-router-dom';
import {
  Users, MessageSquare, Calendar, TrendingUp, DollarSign, Mail, Bell,
  ChevronRight, LogOut, BarChart3, Briefcase, Headphones,
  PenTool, CalendarDays, Shield, Sparkles, UserPlus, Trash2,
  Power, PowerOff, X, Activity, ClipboardList, Plus,
  RefreshCw, Eye, Clock, BarChart2, AlertTriangle, CheckCircle2, Archive, Clapperboard, Loader2, FileText, Building2, Rocket, Cpu, Video, Wand2, PhoneCall, Zap,
  BookOpen, GraduationCap, AlertCircle, Award, ShieldCheck
} from 'lucide-react';
import {
  AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip,
  ResponsiveContainer, PieChart, Pie, Cell, BarChart, Bar
} from 'recharts';
import { useAuth } from '../../context/AuthContext';
import SEO from '../../components/SEO';
import BusinessLinesHub from '../../components/admin/BusinessLinesHub';
import CommandCenterBoard from '../../components/admin/CommandCenterBoard';
import AgentOSHub from '../../components/admin/AgentOSHub';
import WorkspaceHub from '../../components/workspace/WorkspaceHub';
import CompanyCEOHub from '../../components/admin/CompanyCEOHub';
import IntegrationsCenterHub from '../../components/admin/IntegrationsCenterHub';
import PaymentLinksPanel from '../../components/admin/PaymentLinksPanel';
import PromptApprovalPanel from '../../components/admin/PromptApprovalPanel';
import MarketIntelPanel from '../../components/admin/MarketIntelPanel';
import ServicesStudioPanel from '../../components/admin/ServicesStudioPanel';
import MentorsCouncilPanel from '../../components/admin/MentorsCouncilPanel';
import ClientProfilePanel from '../../components/admin/ClientProfilePanel';
import CRMPanel from '../../components/admin/CRMPanel';
import Security2FAPanel from '../../components/admin/Security2FAPanel';
import SkillCenterHub from '../../components/admin/SkillCenterHub';
import CEOOrdersHub from '../../components/admin/CEOOrdersHub';
import ExecutiveFlowHub from '../../components/admin/ExecutiveFlowHub';
import ContractsHub from '../../components/admin/ContractsHub';
import AgentArchitectureHub from '../../components/admin/AgentArchitectureHub';
import BookingConsultantsManager from '../../components/admin/BookingConsultantsManager';
import AIOptimizationHub from '../../components/admin/AIOptimizationHub';
import NeuraliaOSHub from '../../components/admin/NeuraliaOSHub';
import ClientOperationsHub from '../../components/admin/ClientOperationsHub';
import ComplianceOperationsHub from '../../components/admin/ComplianceOperationsHub';
import MediaLabHub from '../../components/admin/MediaLabHub';
import CampaignWarRoomHub from '../../components/admin/CampaignWarRoomHub';
import ProductionOSHub from '../../components/admin/ProductionOSHub';
import ClinicalPanelHub from '../../components/admin/ClinicalPanelHub';
import PartnerOfficeAdminHub from '../../components/admin/PartnerOfficeAdminHub';
import BillingControlHub from '../../components/admin/BillingControlHub';
import Neuralia369TesixHub from '../../components/admin/Neuralia369TesixHub';
import { TerritoryExecutiveMap } from '../../components/admin/TerritoryExecutiveMap';
import AynaraCommandCenterHub from '../../components/admin/AynaraCommandCenterHub';
import AynaraCallsHub from '../../components/admin/AynaraCallsHub';
import SalesPanelHub from '../../components/admin/SalesPanelHub';
import AdminCalendarHub from '../../components/admin/AdminCalendarHub';
import AdminContractsHub from '../../components/admin/AdminContractsHub';
import AdminPortalHub from '../../components/admin/AdminPortalHub';
import EmailLogHub from '../../components/admin/EmailLogHub';
import CampaignKitHub from '../../components/admin/CampaignKitHub';
import PeruPipelineHub from '../../components/admin/PeruPipelineHub';
import WebhooksHub from '../../components/admin/WebhooksHub';
import AdminConnectionsHub from '../../components/admin/AdminConnectionsPage';
import AdminSecurityAuditPage from './AdminSecurityAuditPage';
import CRMImportHub from '../../components/admin/CRMImportHub';
import TikTokConnectPanel from '../../components/admin/TikTokConnectPanel';
import SetupGuide from '../../components/admin/SetupGuide';
import ContentCalendar30 from '../../components/admin/ContentCalendar30';
import IntiWalletPanel from '../../components/admin/IntiWalletPanel';
import PaisesCampaignHub from '../../components/admin/PaisesCampaignHub';
import SimpleConnectionsHub from '../../components/admin/SimpleConnectionsHub';
import CampaignKanban from '../../components/admin/CampaignKanban';
import AynaraHealthMonitor from '../../components/admin/AynaraHealthMonitor';
import AgentsDashboard from '../../components/admin/AgentsDashboard';
import AgenteVentasPanel from '../../components/admin/AgenteVentasPanel';
import AgenteAgendaPanel from '../../components/admin/AgenteAgendaPanel';
import AgenteCRMPanel from '../../components/admin/AgenteCRMPanel';
import AgenteCobrosPanel from '../../components/admin/AgenteCobrosPanel';
import AnalyticsDashboard from '../../components/admin/AnalyticsDashboard';
import CronLogsPanel from '../../components/admin/CronLogsPanel';
import AynaraCommandBar from '../../components/AynaraCommandBar';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// ── Live clock ────────────────────────────────────────────────────────────────
const LiveClock = () => {
  const [time, setTime] = useState(new Date());
  useEffect(() => {
    const t = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(t);
  }, []);
  const hh = time.getHours().toString().padStart(2,'0');
  const mm = time.getMinutes().toString().padStart(2,'0');
  const ss = time.getSeconds().toString().padStart(2,'0');
  const date = time.toLocaleDateString('es-PE', { weekday:'short', day:'numeric', month:'short' });
  return (
    <div className="text-right hidden sm:block">
      <p className="text-lg font-black text-white tracking-widest font-mono leading-none">
        {hh}<span className="text-primary animate-pulse">:</span>{mm}<span className="text-slate-500 text-sm">:{ss}</span>
      </p>
      <p className="text-[11px] text-slate-500 mt-0.5 capitalize">{date} · Lima</p>
    </div>
  );
};

const AGENT_ICONS = {
  COMERCIAL: Briefcase, SOPORTE: Headphones, CONTENIDO: PenTool,
  CITAS: CalendarDays, VENTAS: TrendingUp, ADMIN: Shield, GENERAL: Sparkles
};
const CHART_COLORS = ['#00E5FF', '#4361EE', '#F72585', '#22C55E', '#EAB308', '#A855F7', '#EC4899'];
const ROLE_LABELS = { admin: 'Administrador', agencia: 'Agencia', asociado: 'Asociado', partner: 'Partner', user: 'Usuario', doctora: 'Doctora', enfermera: 'Enfermera', administradora: 'Administradora', community_manager: 'Community Manager' };
const ROLE_COLORS = { admin: 'bg-accent/20 text-accent', agencia: 'bg-indigo-500/20 text-indigo-300', asociado: 'bg-secondary/20 text-secondary', partner: 'bg-primary/20 text-primary', user: 'bg-gray-500/20 text-gray-400', doctora: 'bg-emerald-500/20 text-emerald-300', enfermera: 'bg-cyan-500/20 text-cyan-300', administradora: 'bg-amber-500/20 text-amber-300', community_manager: 'bg-pink-500/20 text-pink-300' };

const buildAdminTerritoryMapItems = (users = [], leads = []) => {
  const leadCounts = leads.reduce((acc, lead) => {
    if (!lead.country) return acc;
    acc[lead.country] = (acc[lead.country] || 0) + 1;
    return acc;
  }, {});

  const routedCounts = leads.reduce((acc, lead) => {
    if (!lead.country || !lead.assigned_partner_name) return acc;
    acc[lead.country] = (acc[lead.country] || 0) + 1;
    return acc;
  }, {});

  const items = [];
  users
    .filter((user) => ['agencia', 'partner', 'asociado'].includes(user.role) && (user.partner_countries || []).length > 0)
    .forEach((user) => {
      (user.partner_countries || []).forEach((country) => {
        items.push({
          country,
          leadCount: leadCounts[country] || 0,
          routedCount: routedCounts[country] || 0,
          exclusive: Boolean(user.country_exclusivity_enabled),
          ownerLabel: `${ROLE_LABELS[user.role] || 'Partner'} · ${user.nombre}`,
        });
      });
    });

  return items.filter((item, index, array) => array.findIndex((candidate) => candidate.country === item.country) === index);
};

// ── Grupos de navegación (simplifica las 50+ pestañas en 7 categorías) ──────
const TAB_GROUPS = {
  resumen:    { label: 'Resumen',        icon: BarChart3,    emoji: '📊', tabs: ['overview','analytics','command','business','control','ceo','ceo_orders','sales_panel'] },
  clientes:   { label: 'Clientes & CRM', icon: Users,        emoji: '👥', tabs: ['crm','crm_import','paises_campaign','leads','client_profile','client_operations','bookings','conversations','team','partner_office'] },
  ia:         { label: 'IA & Agentes',   icon: Sparkles,     emoji: '🤖', tabs: ['agents_dashboard','analytics','cron_logs','aynara_command','aynara_calls','skills','agente_ventas','agente_agenda','agente_crm','agente_cobros','architecture','mentors_council','services_studio','learning','ai_optimization','agentos','workspace'] },
  cobros:     { label: 'Cobros & Intis', icon: Briefcase,    emoji: '💳', tabs: ['billing_control','inti_wallet','contracts','contratos','portal'] },
  contenido:  { label: 'Campañas',       icon: Video,        emoji: '🎯', tabs: ['campaign_kanban','contenido_30','war_room','media_lab','campaign_kit','publishing','email_log','paises_campaign'] },
  conexiones: { label: 'Conexiones',     icon: Zap,          emoji: '🔗', tabs: ['simple_connections','connections','tiktok','setup_guide','webhooks_make','compliance_ops','neuralia_os'] },
  sistema:    { label: 'Sistema',        icon: Cpu,          emoji: '⚙️',  tabs: ['health_monitor','security','security_audit','tesix','neuraliatesix','production_os','clinical_panel','peru_pipeline','calendario','briefings','tasks','agents','market_intel','academy','partner_office'] },
};

const TABS = [
  { id: 'overview',           label: 'Resumen',          icon: BarChart3 },
  { id: 'peru_pipeline',      label: '🇵🇪 Pipeline Peru', icon: TrendingUp },
  { id: 'webhooks_make',      label: 'Make.com',         icon: Zap },
  { id: 'sales_panel',        label: 'Panel Ventas',     icon: TrendingUp },
  { id: 'calendario',         label: 'Calendario Citas', icon: CalendarDays },
  { id: 'contratos',          label: 'Contratos Cliente',icon: Wand2 },
  { id: 'portal',             label: 'Portal Clientes',  icon: Cpu },
  { id: 'tesix',              label: 'Tesix',            icon: Rocket },
  { id: 'aynara_command',     label: 'Aynara',           icon: Sparkles },
  { id: 'aynara_calls',       label: 'Llamadas IA',      icon: PhoneCall },
  { id: 'email_log',          label: 'Correos',          icon: Mail },
  { id: 'campaign_kit',       label: 'Kit Campaña',      icon: Rocket },
  { id: 'ceo',                label: 'CEO Hub',          icon: Briefcase },
  { id: 'connections',        label: 'Conexiones Adv.',  icon: Shield },
  { id: 'simple_connections', label: 'Conexiones',       icon: Zap },
  { id: 'tiktok',             label: 'TikTok',           icon: Zap },
  { id: 'setup_guide',        label: 'Guía Setup',       icon: Shield },
  { id: 'agents_dashboard',   label: 'Panel IA',         icon: Zap },
  { id: 'analytics',          label: 'Analytics',        icon: BarChart2 },
  { id: 'cron_logs',          label: 'Crons',            icon: Clock },
  { id: 'skills',             label: 'Skills',           icon: Sparkles },
  { id: 'agente_ventas',      label: 'Agente Ventas',    icon: TrendingUp },
  { id: 'agente_agenda',      label: 'Agente Agenda',    icon: Calendar },
  { id: 'agente_crm',         label: 'Agente CRM',       icon: Users },
  { id: 'agente_cobros',      label: 'Agente Cobros',    icon: DollarSign },
  { id: 'workspace',          label: 'Workspace',        icon: Wand2 },
  { id: 'agentos',            label: 'Agent OS',         icon: Cpu },
  { id: 'neuralia_os',        label: 'OS 369',           icon: Cpu },
  { id: 'health_monitor',     label: '🛡️ Vigilancia',    icon: ShieldCheck },
  { id: 'compliance_ops',     label: 'Compliance',       icon: Shield },
  { id: 'media_lab',          label: 'Media Lab',        icon: Video },
  { id: 'production_os',      label: 'Production OS',    icon: Clapperboard },
  { id: 'neuraliatesix',      label: 'Neuralia369Tesix', icon: FileText },
  { id: 'clinical_panel',     label: 'Panel Clínico',    icon: Activity },
  { id: 'war_room',           label: 'War Room',         icon: Rocket },
  { id: 'partner_office',     label: 'Partner Office',   icon: Users },
  { id: 'billing_control',    label: 'Cobros',           icon: FileText },
  { id: 'inti_wallet',        label: 'Intis',            icon: Activity },
  { id: 'campaign_kanban',  label: 'Campañas Board',   icon: BarChart3 },
  { id: 'paises_campaign',  label: 'Campañas País',    icon: Zap },
  { id: 'learning',           label: 'Aprendizaje',      icon: Sparkles },
  { id: 'market_intel',       label: 'Panel Mercado',    icon: TrendingUp },
  { id: 'services_studio',    label: 'Estudio IA',       icon: Wand2 },
  { id: 'mentors_council',    label: 'Mentores IA',      icon: Users },
  { id: 'client_profile',     label: 'Ficha Cliente',    icon: Building2 },
  { id: 'crm',                label: 'CRM',              icon: Users },
  { id: 'crm_import',         label: 'Importar BD',      icon: Users },
  { id: 'contenido_30',       label: 'Contenido 30d',    icon: Video },
  { id: 'security',           label: 'Seguridad',        icon: Shield },
  { id: 'security_audit',    label: 'Auditoría & Alertas', icon: ShieldCheck },
  { id: 'client_operations',  label: 'Clientes',         icon: Building2 },
  { id: 'ai_optimization',    label: 'IA rentable',      icon: Activity },
  { id: 'architecture',       label: 'Arquitectura IA',  icon: Cpu },
  { id: 'ceo_orders',         label: 'Órdenes CEO',      icon: Rocket },
  { id: 'command',            label: 'Centro',           icon: Rocket },
  { id: 'business',           label: 'Líneas',           icon: Building2 },
  { id: 'control',            label: 'Operaciones',      icon: Shield },
  { id: 'publishing',         label: 'Publicaciones',    icon: Bell },
  { id: 'tasks',              label: 'Tareas',           icon: ClipboardList },
  { id: 'analytics',          label: 'Analíticas',       icon: Activity },
  { id: 'agents',             label: 'Agentes IA',       icon: Sparkles },
  { id: 'team',               label: 'Equipo',           icon: Users },
  { id: 'leads',              label: 'Leads',            icon: Mail },
  { id: 'briefings',          label: 'Briefings',        icon: FileText },
  { id: 'contracts',          label: 'Contratos',        icon: FileText },
  { id: 'conversations',      label: 'Conversaciones',   icon: MessageSquare },
  { id: 'bookings',           label: 'Citas',            icon: Calendar },
  { id: 'academy',            label: 'Academy',          icon: BookOpen },
];

const STATUS_CONFIG = {
  pendiente: { label: 'Pendiente', color: 'bg-yellow-500/20 text-yellow-400', icon: Clock },
  en_proceso: { label: 'En Proceso', color: 'bg-blue-500/20 text-blue-400', icon: Loader2 },
  completado: { label: 'Completado', color: 'bg-green-500/20 text-green-400', icon: CheckCircle2 },
  archivado: { label: 'Archivado', color: 'bg-gray-500/20 text-gray-400', icon: Archive },
};

const PRIORITY_CONFIG = {
  baja: { label: 'Baja', color: 'text-gray-400 border-gray-500/30' },
  media: { label: 'Media', color: 'text-blue-400 border-blue-500/30' },
  alta: { label: 'Alta', color: 'text-orange-400 border-orange-500/30' },
  urgente: { label: 'Urgente', color: 'text-red-400 border-red-500/30' },
};

const SOCIAL_STATUS_CONFIG = {
  borrador: { label: 'Borrador', color: 'bg-yellow-500/20 text-yellow-400', icon: Clock },
  en_proceso: { label: 'En Proceso', color: 'bg-blue-500/20 text-blue-400', icon: Loader2 },
  listo: { label: 'Listo', color: 'bg-green-500/20 text-green-400', icon: CheckCircle2 },
};

const APPROVAL_CONFIG = {
  pendiente: 'bg-yellow-500/15 text-yellow-400 border-yellow-500/30',
  aprobado: 'bg-green-500/15 text-green-400 border-green-500/30',
  rechazado: 'bg-red-500/15 text-red-400 border-red-500/30',
};

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload?.length) {
    return (
      <div className="bg-[#0A1A3F] border border-[rgba(255,255,255,0.1)] rounded-lg px-3 py-2 shadow-lg">
        <p className="text-gray-400 text-xs">{label}</p>
        <p className="text-[#00E5FF] font-bold text-sm">{payload[0].value}</p>
      </div>
    );
  }
  return null;
};

export default function AdminDashboard() {
  const { user, authFetch, logout } = useAuth();
  const navigate = useNavigate();
  const [tab, setTab] = useState('overview');
  const [activeGroup, setActiveGroup] = useState('resumen');
  const [metrics, setMetrics] = useState(null);
  const [analytics, setAnalytics] = useState(null);
  const [agents, setAgents] = useState([]);
  const [leads, setLeads] = useState([]);
  const [serviceIntakes, setServiceIntakes] = useState([]);
  const [conversations, setConversations] = useState([]);
  const [bookings, setBookings] = useState([]);
  const [teamUsers, setTeamUsers] = useState([]);
  const [selectedConvo, setSelectedConvo] = useState(null);
  const [convoMessages, setConvoMessages] = useState([]);
  const [showCreateUser, setShowCreateUser] = useState(false);
  const [newUser, setNewUser] = useState({ nombre: '', email: '', password: '', empresa: '', role: 'partner', assigned_agents: [], partner_countries: [], country_exclusivity_enabled: false });
  const [toast, setToast] = useState(null);
  const [controlCenter, setControlCenter] = useState(null);
  const [commandCenter, setCommandCenter] = useState(null);
  const [executiveFlow, setExecutiveFlow] = useState(null);
  const [businessLines, setBusinessLines] = useState(null);
  const [pricingConfig, setPricingConfig] = useState(null);
  const [pricingForm, setPricingForm] = useState({ publico: 0, agencia: 45, partner: 52, asociado: 48 });
  const [socialOrders, setSocialOrders] = useState([]);
  const [showCreateSocialOrder, setShowCreateSocialOrder] = useState(false);
  const [selectedSocialOrder, setSelectedSocialOrder] = useState(null);
  const [newSocialOrder, setNewSocialOrder] = useState({
    campaign_name: '', business_goal: '', audience: '', brand_voice: 'Profesional, cercano y persuasivo',
    offers: '', platforms: ['instagram', 'facebook', 'youtube'], weeks: 4, posts_per_week: 3,
    include_images: true, include_calendar: true, include_strategy: true, auto_execute: true
  });
  const [transcriptFile, setTranscriptFile] = useState(null);
  const [transcriptForm, setTranscriptForm] = useState({ language: 'es', prompt: '' });
  const [transcriptionLoading, setTranscriptionLoading] = useState(false);
  const [transcriptionResult, setTranscriptionResult] = useState(null);
  // Tasks state
  const [tasks, setTasks] = useState([]);
  const [taskFilter, setTaskFilter] = useState('all');
  const [showCreateTask, setShowCreateTask] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const [newTask, setNewTask] = useState({ title: '', description: '', assigned_agents: [], priority: 'media', deadline: '', auto_execute: true });
  const [selectedWorkflowDetail, setSelectedWorkflowDetail] = useState(null);
  const [workflowDetailLoading, setWorkflowDetailLoading] = useState(false);

  useEffect(() => {
    if (!user) { navigate('/login'); return; }
    if (user.role !== 'admin') { navigate('/panel'); return; }
    loadMetrics();
    loadAgents();
    loadAnalytics();
    loadExecutiveFlow();
  }, [user]);

  useEffect(() => {
    if (tab === 'leads') loadLeads();
    if (tab === 'briefings') loadServiceIntakes();
    if (tab === 'conversations') loadConversations();
    if (tab === 'bookings') loadBookings();
    if (tab === 'team') loadTeam();
    if (tab === 'control') { loadControlCenter(); loadPricingConfig(); }
    if (tab === 'command') loadCommandCenter();
    if (tab === 'business') loadBusinessLines();
    if (tab === 'publishing') loadSocialOrders();
    if (tab === 'tasks') loadTasks();
    if (tab === 'analytics' && !analytics) loadAnalytics();
    if (tab === 'overview' && !executiveFlow) loadExecutiveFlow();
  }, [tab]);

  useEffect(() => {
    if (tab !== 'publishing' || !selectedSocialOrder || selectedSocialOrder.status === 'listo') return undefined;
    const interval = setInterval(() => {
      loadSocialOrderDetail(selectedSocialOrder.id);
      loadSocialOrders();
    }, 5000);
    return () => clearInterval(interval);
  }, [tab, selectedSocialOrder]);

  const showToast = (msg, type = 'success') => { setToast({ msg, type }); setTimeout(() => setToast(null), 3000); };

  const loadMetrics = async () => { try { const r = await authFetch(`${API}/admin/metrics`); setMetrics(await r.json()); } catch {} };
  const loadAnalytics = async () => { try { const r = await authFetch(`${API}/admin/analytics`); setAnalytics(await r.json()); } catch {} };
  const loadAgents = async () => { try { const r = await authFetch(`${API}/admin/agents`); setAgents((await r.json()).agents); } catch {} };
  const loadExecutiveFlow = async () => { try { const r = await authFetch(`${API}/admin/executive-flow-hub`); setExecutiveFlow(await r.json()); } catch {} };
  const loadLeads = async () => { try { const r = await authFetch(`${API}/admin/leads`); setLeads((await r.json()).leads); } catch {} };
  const loadServiceIntakes = async () => { try { const r = await authFetch(`${API}/admin/service-intakes`); setServiceIntakes((await r.json()).intakes); } catch {} };
  const loadConversations = async () => { try { const r = await authFetch(`${API}/admin/conversations`); setConversations((await r.json()).conversations); } catch {} };
  const loadBookings = async () => { try { const r = await authFetch(`${API}/admin/bookings`); setBookings((await r.json()).bookings); } catch {} };
  const loadTeam = async () => { try { const r = await authFetch(`${API}/admin/users`); setTeamUsers((await r.json()).users); } catch {} };
  const loadControlCenter = async () => { try { const r = await authFetch(`${API}/admin/control-center/summary`); setControlCenter(await r.json()); } catch {} };
  const loadCommandCenter = async () => { try { const r = await authFetch(`${API}/admin/command-center/board`); setCommandCenter(await r.json()); } catch {} };
  const loadBusinessLines = async () => { try { const r = await authFetch(`${API}/admin/business-lines/overview`); setBusinessLines(await r.json()); } catch {} };
  const loadPricingConfig = async () => {
    try {
      const r = await authFetch(`${API}/admin/pricing-config`);
      const data = await r.json();
      setPricingConfig(data.roles);
      setPricingForm({
        publico: data.roles?.publico?.discount_percent ?? 0,
        agencia: data.roles?.agencia?.discount_percent ?? 45,
        partner: data.roles?.partner?.discount_percent ?? 52,
        asociado: data.roles?.asociado?.discount_percent ?? 48,
      });
    } catch {}
  };
  const loadSocialOrders = async () => { try { const r = await authFetch(`${API}/admin/social-orders`); setSocialOrders((await r.json()).orders); } catch {} };
  const loadSocialOrderDetail = async (id) => { try { const r = await authFetch(`${API}/admin/social-orders/${id}`); setSelectedSocialOrder((await r.json()).order); } catch {} };

  const createSocialOrder = async (e) => {
    e.preventDefault();
    if (newSocialOrder.platforms.length === 0) { showToast('Selecciona al menos una plataforma', 'error'); return; }
    try {
      const r = await authFetch(`${API}/admin/social-orders`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...newSocialOrder, offers: newSocialOrder.offers || null })
      });
      if (!r.ok) { const d = await r.json(); showToast(d.detail || 'Error', 'error'); return; }
      showToast('Orden editorial creada — los agentes ya están preparando borradores');
      setShowCreateSocialOrder(false);
      setNewSocialOrder({
        campaign_name: '', business_goal: '', audience: '', brand_voice: 'Profesional, cercano y persuasivo',
        offers: '', platforms: ['instagram', 'facebook', 'youtube'], weeks: 4, posts_per_week: 3,
        include_images: true, include_calendar: true, include_strategy: true, auto_execute: true
      });
      setTimeout(loadSocialOrders, 1000);
    } catch {
      showToast('Error al crear la orden editorial', 'error');
    }
  };

  const updateSocialOrderApproval = async (orderId, approvalStatus) => {
    try {
      const r = await authFetch(`${API}/admin/social-orders/${orderId}`, {
        method: 'PATCH', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ approval_status: approvalStatus })
      });
      if (!r.ok) { const d = await r.json(); showToast(d.detail || 'Error', 'error'); return; }
      showToast(`Orden ${approvalStatus}`);
      if (selectedSocialOrder?.id === orderId) loadSocialOrderDetail(orderId);
      loadSocialOrders();
    } catch {
      showToast('No se pudo actualizar la aprobación', 'error');
    }
  };

  const retrySocialOrder = async (orderId) => {
    try {
      const r = await authFetch(`${API}/admin/social-orders/${orderId}/retry`, { method: 'POST' });
      if (!r.ok) { const d = await r.json(); showToast(d.detail || 'No se pudo reintentar', 'error'); return; }
      showToast('Campaña reenviada a los agentes');
      setTimeout(() => {
        loadSocialOrders();
        if (selectedSocialOrder?.id === orderId) loadSocialOrderDetail(orderId);
        loadControlCenter();
      }, 800);
    } catch {
      showToast('No se pudo reintentar la campaña', 'error');
    }
  };

  const transcribeAudio = async (e) => {
    e.preventDefault();
    if (!transcriptFile) { showToast('Selecciona un audio primero', 'error'); return; }
    try {
      setTranscriptionLoading(true);
      const formData = new FormData();
      formData.append('audio_file', transcriptFile);
      formData.append('language', transcriptForm.language);
      if (transcriptForm.prompt.trim()) formData.append('prompt', transcriptForm.prompt.trim());
      const r = await authFetch(`${API}/admin/transcribe-audio`, { method: 'POST', body: formData });
      const data = await r.json();
      if (!r.ok) { showToast(data.detail || 'No se pudo transcribir', 'error'); return; }
      setTranscriptionResult(data.transcript);
      setTranscriptFile(null);
      setTranscriptForm({ language: 'es', prompt: '' });
      loadControlCenter();
      showToast('Audio transcrito correctamente');
    } catch {
      showToast('Error al transcribir audio', 'error');
    } finally {
      setTranscriptionLoading(false);
    }
  };

  const savePricingConfig = async (e) => {
    e.preventDefault();
    try {
      const r = await authFetch(`${API}/admin/pricing-config`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          publico_discount_percent: Number(pricingForm.publico),
          agencia_discount_percent: Number(pricingForm.agencia),
          partner_discount_percent: Number(pricingForm.partner),
          asociado_discount_percent: Number(pricingForm.asociado)
        })
      });
      const data = await r.json();
      if (!r.ok) { showToast(data.detail || 'No se pudo guardar', 'error'); return; }
      setPricingConfig(data.roles);
      showToast('Pricing por rol actualizado');
    } catch {
      showToast('Error al guardar el pricing', 'error');
    }
  };

  const createCommandCenterCard = async (payload) => {
    try {
      const r = await authFetch(`${API}/admin/command-center/cards`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
      });
      const data = await r.json();
      if (!r.ok) { showToast(data.detail || 'No se pudo crear la tarjeta', 'error'); return; }
      showToast('Tarjeta creada en el Centro de Mando');
      loadCommandCenter();
    } catch {
      showToast('No se pudo crear la tarjeta', 'error');
    }
  };

  const updateCommandCenterCard = async (cardId, payload) => {
    try {
      const r = await authFetch(`${API}/admin/command-center/cards/${cardId}`, {
        method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
      });
      const data = await r.json();
      if (!r.ok) { showToast(data.detail || 'No se pudo actualizar la tarjeta', 'error'); return; }
      showToast('Tarjeta actualizada');
      loadCommandCenter();
    } catch {
      showToast('No se pudo actualizar la tarjeta', 'error');
    }
  };

  const seedLaunchMaster = async () => {
    try {
      const r = await authFetch(`${API}/admin/command-center/seed-launch`, { method: 'POST' });
      const data = await r.json();
      if (!r.ok) { showToast(data.detail || 'No se pudo preparar el lanzamiento', 'error'); return; }
      showToast(data.launch_order_created ? 'Campaña maestra de lanzamiento creada y enviada a los agentes' : 'La campaña maestra ya existía; el tablero quedó sincronizado');
      loadCommandCenter();
      loadSocialOrders();
    } catch {
      showToast('No se pudo preparar el lanzamiento', 'error');
    }
  };

  // Task functions
  const loadTasks = async () => { try { const r = await authFetch(`${API}/admin/tasks`); setTasks((await r.json()).tasks); } catch {} };

  const rerunPostConsultingWorkflow = async (workflowId) => {
    try {
      const r = await authFetch(`${API}/admin/post-consulting-workflows/${workflowId}/rerun`, { method: 'POST' });
      const data = await r.json();
      if (!r.ok) { showToast(data.detail || 'No se pudo reenviar el workflow', 'error'); return; }
      showToast('Workflow post-consultoría reenviado');
      loadServiceIntakes();
    } catch {
      showToast('No se pudo reenviar el workflow', 'error');
    }
  };

  const backfillPostConsultingWorkflows = async () => {
    try {
      const r = await authFetch(`${API}/admin/post-consulting-workflows/backfill`, { method: 'POST' });
      const data = await r.json();
      if (!r.ok) { showToast(data.detail || 'No se pudo activar los workflows pendientes', 'error'); return; }
      showToast(data.created > 0 ? `Se activaron ${data.created} workflows pendientes` : 'No había workflows pendientes por activar');
      loadServiceIntakes();
    } catch {
      showToast('No se pudo activar los workflows pendientes', 'error');
    }
  };

  const openPostConsultingWorkflowDetail = async (workflowId) => {
    try {
      setWorkflowDetailLoading(true);
      const r = await authFetch(`${API}/admin/post-consulting-workflows/${workflowId}`);
      const data = await r.json();
      if (!r.ok) { showToast(data.detail || 'No se pudo cargar el informe completo', 'error'); return; }
      setSelectedWorkflowDetail(data);
    } catch {
      showToast('No se pudo cargar el informe completo', 'error');
    } finally {
      setWorkflowDetailLoading(false);
    }
  };

  const closePostConsultingWorkflowDetail = () => setSelectedWorkflowDetail(null);

  const syncPostConsultingWorkflowCeoOrder = async (workflowId) => {
    try {
      const r = await authFetch(`${API}/admin/post-consulting-workflows/${workflowId}/sync-ceo-order`, { method: 'POST' });
      const data = await r.json();
      if (!r.ok) { showToast(data.detail || 'No se pudo sincronizar la orden CEO', 'error'); return; }
      showToast('Orden CEO sincronizada');
      openPostConsultingWorkflowDetail(workflowId);
    } catch {
      showToast('No se pudo sincronizar la orden CEO', 'error');
    }
  };
  const loadTaskDetail = async (id) => { try { const r = await authFetch(`${API}/admin/tasks/${id}`); setSelectedTask((await r.json()).task); } catch {} };

  const createTask = async (e) => {
    e.preventDefault();
    if (newTask.assigned_agents.length === 0) { showToast('Selecciona al menos un agente', 'error'); return; }
    try {
      const r = await authFetch(`${API}/admin/tasks`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...newTask, deadline: newTask.deadline || null })
      });
      if (!r.ok) { const d = await r.json(); showToast(d.detail || 'Error', 'error'); return; }
      showToast('Tarea creada — los agentes están trabajando');
      setShowCreateTask(false);
      setNewTask({ title: '', description: '', assigned_agents: [], priority: 'media', deadline: '', auto_execute: true });
      setTimeout(loadTasks, 1000);
    } catch { showToast('Error al crear tarea', 'error'); }
  };

  const updateTaskStatus = async (taskId, status) => {
    try {
      await authFetch(`${API}/admin/tasks/${taskId}`, { method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ status }) });
      loadTasks();
      if (selectedTask?.id === taskId) loadTaskDetail(taskId);
      showToast(`Tarea movida a ${STATUS_CONFIG[status]?.label}`);
    } catch {}
  };

  const retryTask = async (taskId) => {
    try {
      await authFetch(`${API}/admin/tasks/${taskId}/retry`, { method: 'POST' });
      showToast('Tarea reenviada a los agentes');
      setTimeout(loadTasks, 1000);
      if (selectedTask?.id === taskId) setTimeout(() => loadTaskDetail(taskId), 2000);
    } catch {}
  };

  const deleteTask = async (taskId) => {
    if (!window.confirm('¿Eliminar esta tarea?')) return;
    try {
      await authFetch(`${API}/admin/tasks/${taskId}`, { method: 'DELETE' });
      setSelectedTask(null);
      loadTasks();
      showToast('Tarea eliminada');
    } catch {}
  };

  const loadConvoDetail = async (sid) => {
    setSelectedConvo(sid);
    try { const r = await authFetch(`${API}/admin/conversations/${sid}`); setConvoMessages((await r.json()).messages); } catch {}
  };

  const toggleAgent = async (agentType, currentActive) => {
    try {
      await authFetch(`${API}/admin/agents/${agentType}`, {
        method: 'PATCH', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ active: !currentActive })
      });
      loadAgents();
      showToast(`Agente ${agentType} ${!currentActive ? 'activado' : 'desactivado'}`);
    } catch {}
  };

  const createUser = async (e) => {
    e.preventDefault();
    try {
      const r = await authFetch(`${API}/admin/users`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newUser)
      });
      if (!r.ok) { const d = await r.json(); showToast(d.detail || 'Error', 'error'); return; }
      showToast(`${ROLE_LABELS[newUser.role]} creado`);
      setShowCreateUser(false);
      setNewUser({ nombre: '', email: '', password: '', empresa: '', role: 'partner', assigned_agents: [], partner_countries: [], country_exclusivity_enabled: false });
      loadTeam();
    } catch { showToast('Error al crear usuario', 'error'); }
  };

  const updateUserRole = async (userId, newRole) => {
    try {
      await authFetch(`${API}/admin/users/${userId}`, { method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ role: newRole }) });
      loadTeam(); showToast('Rol actualizado');
    } catch {}
  };

  const toggleUserActive = async (userId, currentActive) => {
    try {
      await authFetch(`${API}/admin/users/${userId}`, { method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ active: !currentActive }) });
      loadTeam(); showToast(`Acceso ${!currentActive ? 'activado' : 'revocado'}`);
    } catch {}
  };

  const deleteUser = async (userId, nombre) => {
    if (!window.confirm(`¿Eliminar a ${nombre}?`)) return;
    try { await authFetch(`${API}/admin/users/${userId}`, { method: 'DELETE' }); loadTeam(); showToast('Eliminado'); } catch {}
  };

  const handleLogout = () => { logout(); navigate('/'); };
  const goToAdminTab = (nextTab) => {
    setTab(nextTab);
    setSelectedConvo(null);
    setSelectedTask(null);
    setSelectedSocialOrder(null);
    // Auto-switch group when navigating to a tab
    const groupForTab = Object.entries(TAB_GROUPS).find(([, g]) => g.tabs.includes(nextTab));
    if (groupForTab) setActiveGroup(groupForTab[0]);
  };

  const MetricCard = ({ icon: Icon, label, value, color, accent = 'from-primary to-cyan-400' }) => (
    <motion.div
      initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }}
      whileHover={{ y: -2 }}
      className="relative overflow-hidden rounded-2xl border border-white/[0.06] bg-[#0b1a35]/80 p-5 group hover:border-primary/25 transition-all duration-300 cursor-default"
    >
      {/* Gradient accent line */}
      <div className={`absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r ${accent} opacity-50 group-hover:opacity-100 transition-opacity duration-300`} />
      {/* Icon */}
      <div className={`w-9 h-9 rounded-xl flex items-center justify-center mb-3 ${color}`}>
        <Icon className="w-4 h-4" />
      </div>
      {/* Number */}
      <p className="text-3xl font-black text-white tracking-tight leading-none">{value}</p>
      {/* Label */}
      <p className="text-[11px] text-slate-500 uppercase tracking-widest mt-2 font-medium">{label}</p>
    </motion.div>
  );

  if (!user || user.role !== 'admin') return null;

  return (
    <>
      <SEO title="Centro de Control — Neuralia369" description="Panel admin" />

      <AnimatePresence>
        {toast && (
          <motion.div initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -20 }}
            className={`fixed top-24 right-6 z-[9999] px-4 py-3 rounded-xl text-sm font-medium shadow-lg ${
              toast.type === 'error' ? 'bg-red-500/90 text-white' : 'bg-primary/90 text-[#0A1A3F]'
            }`}>{toast.msg}</motion.div>
        )}
      </AnimatePresence>

      <div className="min-h-screen pt-20 pb-12 px-4" data-testid="admin-dashboard">
        <div className="max-w-7xl mx-auto">

          {/* ── Header ─────────────────────────────────────────────────── */}
          <div className="relative overflow-hidden rounded-2xl border border-white/[0.07] bg-gradient-to-r from-[#081428] via-[#0d1f3c] to-[#081428] mb-6 p-5 flex items-center justify-between gap-4">
            {/* Glow */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-96 h-1 bg-gradient-to-r from-transparent via-primary to-transparent opacity-60 pointer-events-none" />
            <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_left,rgba(0,229,255,0.04)_0%,transparent_60%)] pointer-events-none" />

            <div className="relative">
              <div className="flex items-center gap-3 mb-1">
                <div className="w-2 h-2 rounded-full bg-emerald-400 shadow-[0_0_6px_rgba(52,211,153,0.8)] animate-pulse" />
                <h1 className="text-2xl sm:text-3xl font-black text-white tracking-tight">
                  Centro de Control
                </h1>
              </div>
              <p className="text-slate-400 text-sm">
                Neuralia<span className="bg-[linear-gradient(90deg,#4285F4_0%,#EA4335_33%,#FBBC05_66%,#34A853_100%)] bg-clip-text text-transparent font-bold">369</span>
                {' '}·{' '}<span className="text-slate-300">{user.nombre}</span>
              </p>
            </div>

            <div className="flex items-center gap-4 relative">
              <LiveClock />
              <div className="hidden md:flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-emerald-500/10 border border-emerald-500/20">
                <div className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />
                <span className="text-xs text-emerald-400 font-semibold">Todos los sistemas activos</span>
              </div>
              <button onClick={handleLogout} className="flex items-center gap-1.5 px-4 py-2 rounded-xl text-sm font-semibold text-slate-300 border border-white/10 hover:border-red-500/30 hover:text-red-400 transition-all duration-200" data-testid="admin-logout">
                <LogOut className="w-4 h-4" /> Salir
              </button>
            </div>
          </div>

          {/* ── Navigation ─────────────────────────────────────────── */}
          <div className="flex gap-2 mb-6 overflow-x-auto pb-2" data-testid="admin-tabs">
            <div className="w-full space-y-3">
              {/* Group buttons */}
              <div className="flex gap-2 overflow-x-auto pb-1 flex-wrap" data-testid="admin-group-tabs">
                {Object.entries(TAB_GROUPS).map(([gid, g]) => {
                  const active = activeGroup === gid;
                  return (
                    <button
                      key={gid}
                      onClick={() => { setActiveGroup(gid); }}
                      data-testid={`admin-group-${gid}`}
                      className={`flex items-center gap-1.5 px-4 py-2 rounded-xl text-sm font-semibold whitespace-nowrap transition-all duration-200 border ${
                        active
                          ? 'bg-gradient-to-r from-primary to-cyan-400 text-[#081428] border-transparent shadow-[0_0_16px_rgba(0,229,255,0.25)]'
                          : 'bg-white/[0.03] text-slate-400 border-white/[0.06] hover:border-primary/30 hover:text-white hover:bg-white/[0.06]'
                      }`}
                    >
                      <span className="text-base leading-none">{g.emoji}</span>
                      <span className="hidden sm:inline">{g.label}</span>
                    </button>
                  );
                })}
              </div>
              {/* Sub-tab buttons */}
              <div className="flex gap-1.5 overflow-x-auto pb-1 flex-wrap" data-testid="admin-subtabs">
                {(TAB_GROUPS[activeGroup]?.tabs || [])
                  .map(tid => TABS.find(t => t.id === tid))
                  .filter(Boolean)
                  .map(t => (
                    <button key={t.id} onClick={() => goToAdminTab(t.id)}
                      className={`flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition-all duration-200 ${
                        tab === t.id
                          ? 'bg-primary/15 text-primary border border-primary/50 shadow-[0_0_8px_rgba(0,229,255,0.15)]'
                          : 'bg-white/[0.03] text-slate-500 border border-white/[0.05] hover:border-primary/20 hover:text-slate-300'
                      }`} data-testid={`admin-tab-${t.id}`}>
                      <t.icon className="w-3 h-3" /> {t.label}
                    </button>
                  ))
                }
              </div>
            </div>
          </div>

          {/* ===== OVERVIEW ===== */}
          {tab === 'overview' && metrics && (
            <div className="space-y-6">
              <ExecutiveFlowHub data={executiveFlow} onNavigate={goToAdminTab} />

              {/* ── KPI Strip ── */}
              <div className="grid grid-cols-3 gap-4" data-testid="admin-kpi-strip">
                {[
                  { label: 'Leads en pipeline', value: metrics.metrics.leads || 0, icon: TrendingUp, gradient: 'from-cyan-500 to-blue-500', bg: 'bg-cyan-500/10 text-cyan-300' },
                  { label: 'Conversaciones activas', value: metrics.metrics.conversations || 0, icon: MessageSquare, gradient: 'from-violet-500 to-purple-500', bg: 'bg-violet-500/10 text-violet-300' },
                  { label: 'Usuarios registrados', value: metrics.metrics.users || 0, icon: Users, gradient: 'from-emerald-500 to-teal-500', bg: 'bg-emerald-500/10 text-emerald-300' },
                ].map((kpi) => (
                  <div key={kpi.label} className="relative overflow-hidden rounded-2xl border border-white/[0.07] bg-gradient-to-br from-[#0d1f3c] to-[#081428] p-6">
                    <div className={`absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r ${kpi.gradient} opacity-70`} />
                    <div className={`w-10 h-10 rounded-xl flex items-center justify-center mb-4 ${kpi.bg}`}>
                      <kpi.icon className="w-5 h-5" />
                    </div>
                    <p className="text-4xl font-black text-white tracking-tight">{kpi.value}</p>
                    <p className="text-xs text-slate-500 uppercase tracking-widest mt-2">{kpi.label}</p>
                  </div>
                ))}
              </div>

              <div className="grid grid-cols-2 md:grid-cols-4 gap-3" data-testid="admin-metrics">
                <MetricCard icon={Users} label="Agencias" value={metrics.metrics.agencias || 0} color="bg-indigo-500/15 text-indigo-300" accent="from-indigo-500 to-blue-400" />
                <MetricCard icon={Users} label="Partners" value={metrics.metrics.partners} color="bg-blue-500/15 text-blue-400" accent="from-blue-500 to-cyan-400" />
                <MetricCard icon={Users} label="Asociados" value={metrics.metrics.asociados} color="bg-secondary/15 text-secondary" accent="from-secondary to-pink-400" />
                <MetricCard icon={Mail} label="Leads" value={metrics.metrics.leads} color="bg-green-500/15 text-green-400" accent="from-green-500 to-emerald-400" />
                <MetricCard icon={Calendar} label="Citas" value={metrics.metrics.bookings} color="bg-purple-500/15 text-purple-400" accent="from-purple-500 to-violet-400" />
                <MetricCard icon={TrendingUp} label="Ventas" value={metrics.metrics.sales} color="bg-yellow-500/15 text-yellow-400" accent="from-yellow-500 to-amber-400" />
                <MetricCard icon={MessageSquare} label="Conversaciones" value={metrics.metrics.conversations} color="bg-primary/15 text-primary" accent="from-primary to-cyan-300" />
                <MetricCard icon={Bell} label="Newsletter" value={metrics.metrics.newsletter_subs} color="bg-accent/15 text-accent" accent="from-accent to-rose-400" />
              </div>

              {/* Mini charts in overview */}
              {analytics && (
                <div className="grid md:grid-cols-2 gap-6">
                  <div className="glass-card p-6">
                    <h3 className="text-text-heading font-heading font-semibold text-lg mb-4 flex items-center gap-2">
                      <Activity className="w-5 h-5 text-primary" /> Conversaciones (30 días)
                    </h3>
                    <ResponsiveContainer width="100%" height={200}>
                      <AreaChart data={analytics.daily_chats}>
                        <defs>
                          <linearGradient id="chatGrad" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#00E5FF" stopOpacity={0.3} />
                            <stop offset="95%" stopColor="#00E5FF" stopOpacity={0} />
                          </linearGradient>
                        </defs>
                        <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)" />
                        <XAxis dataKey="date" tick={{ fill: '#64748B', fontSize: 11 }} tickFormatter={v => v.slice(5)} />
                        <YAxis tick={{ fill: '#64748B', fontSize: 11 }} />
                        <Tooltip content={<CustomTooltip />} />
                        <Area type="monotone" dataKey="count" stroke="#00E5FF" fill="url(#chatGrad)" strokeWidth={2} />
                      </AreaChart>
                    </ResponsiveContainer>
                  </div>

                  <div className="glass-card p-6">
                    <h3 className="text-text-heading font-heading font-semibold text-lg mb-4 flex items-center gap-2">
                      <Sparkles className="w-5 h-5 text-primary" /> Distribución de Agentes
                    </h3>
                    <ResponsiveContainer width="100%" height={200}>
                      <PieChart>
                        <Pie data={analytics.agent_distribution} cx="50%" cy="50%" innerRadius={50} outerRadius={80}
                          dataKey="count" nameKey="agent" paddingAngle={3}>
                          {analytics.agent_distribution.map((_, i) => (
                            <Cell key={i} fill={CHART_COLORS[i % CHART_COLORS.length]} />
                          ))}
                        </Pie>
                        <Tooltip content={({ active, payload }) => active && payload?.length ? (
                          <div className="bg-[#0A1A3F] border border-[rgba(255,255,255,0.1)] rounded-lg px-3 py-2 shadow-lg">
                            <p className="text-white text-xs font-medium">{payload[0].name}</p>
                            <p className="text-[#00E5FF] font-bold text-sm">{payload[0].value} chats</p>
                          </div>
                        ) : null} />
                      </PieChart>
                    </ResponsiveContainer>
                    <div className="flex flex-wrap gap-2 mt-2">
                      {analytics.agent_distribution.map((a, i) => (
                        <span key={i} className="flex items-center gap-1.5 text-xs text-text-muted">
                          <span className="w-2.5 h-2.5 rounded-full" style={{ background: CHART_COLORS[i % CHART_COLORS.length] }} />
                          {a.agent}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              <div className="grid md:grid-cols-2 gap-6">
                <div className="glass-card p-6">
                  <h3 className="text-text-heading font-heading font-semibold text-lg mb-4 flex items-center gap-2">
                    <Mail className="w-5 h-5 text-primary" /> Últimos Leads
                  </h3>
                  <div className="space-y-2">
                    {metrics.recent_leads.map((l, i) => (
                      <div key={i} className="flex items-start justify-between p-3 rounded-lg bg-card border border-border-subtle">
                        <div className="min-w-0">
                          <p className="text-text-heading text-base font-medium truncate">{l.nombre}</p>
                          <p className="text-text-muted text-sm truncate">{l.email}</p>
                        </div>
                        <span className="text-text-muted text-xs whitespace-nowrap ml-2">{new Date(l.timestamp).toLocaleDateString('es')}</span>
                      </div>
                    ))}
                    {metrics.recent_leads.length === 0 && <p className="text-text-muted text-sm">Sin leads recientes</p>}
                  </div>
                </div>
                <div className="glass-card p-6">
                  <h3 className="text-text-heading font-heading font-semibold text-lg mb-4 flex items-center gap-2">
                    <Calendar className="w-5 h-5 text-primary" /> Últimas Citas
                  </h3>
                  <div className="space-y-2">
                    {metrics.recent_bookings.map((b, i) => (
                      <div key={i} className="flex items-start justify-between p-3 rounded-lg bg-card border border-border-subtle">
                        <div className="min-w-0">
                          <p className="text-text-heading text-base font-medium truncate">{b.nombre}</p>
                          <p className="text-primary text-sm font-medium">{b.fecha} · {b.hora}</p>
                        </div>
                        <span className={`text-xs px-2 py-1 rounded-full ${b.status === 'confirmed' ? 'bg-green-500/20 text-green-400' : 'bg-yellow-500/20 text-yellow-400'}`}>
                          {b.status === 'confirmed' ? 'OK' : b.status}
                        </span>
                      </div>
                    ))}
                    {metrics.recent_bookings.length === 0 && <p className="text-text-muted text-sm">Sin citas recientes</p>}
                  </div>
                </div>
              </div>
            </div>
          )}

          {tab === 'command' && commandCenter && (
            <CommandCenterBoard
              data={commandCenter}
              onRefresh={loadCommandCenter}
              onSeedLaunch={seedLaunchMaster}
              onCreateCard={createCommandCenterCard}
              onUpdateCard={updateCommandCenterCard}
            />
          )}

          {tab === 'agentos' && (
            <AgentOSHub authFetch={authFetch} />
          )}

          {tab === 'aynara_command' && (
            <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} data-testid="admin-tab-aynara_command-panel">
              <AynaraCommandCenterHub authFetch={authFetch} />
            </motion.div>
          )}

          {tab === 'neuralia_os' && (
            <NeuraliaOSHub authFetch={authFetch} />
          )}

          {tab === 'compliance_ops' && (
            <ComplianceOperationsHub authFetch={authFetch} />
          )}

          {tab === 'media_lab' && (
            <MediaLabHub authFetch={authFetch} />
          )}

          {tab === 'production_os' && (
            <ProductionOSHub authFetch={authFetch} />
          )}

          {tab === 'neuraliatesix' && (
            <Neuralia369TesixHub authFetch={authFetch} />
          )}

          {tab === 'clinical_panel' && (
            <ClinicalPanelHub authFetch={authFetch} />
          )}

          {tab === 'peru_pipeline' && (
            <PeruPipelineHub authFetch={authFetch} />
          )}

          {tab === 'webhooks_make' && (
            <WebhooksHub authFetch={authFetch} />
          )}

          {tab === 'war_room' && (
            <CampaignWarRoomHub authFetch={authFetch} />
          )}

          {tab === 'partner_office' && (
            <PartnerOfficeAdminHub authFetch={authFetch} />
          )}

          {tab === 'billing_control' && (
            <div className="space-y-10">
              <PaymentLinksPanel authFetch={authFetch} />
              <BillingControlHub authFetch={authFetch} />
            </div>
          )}

          {tab === 'learning' && (
            <PromptApprovalPanel authFetch={authFetch} />
          )}

          {tab === 'market_intel' && (
            <MarketIntelPanel authFetch={authFetch} />
          )}

          {tab === 'services_studio' && (
            <ServicesStudioPanel authFetch={authFetch} />
          )}

          {tab === 'mentors_council' && (
            <MentorsCouncilPanel authFetch={authFetch} />
          )}

          {tab === 'client_profile' && (
            <ClientProfilePanel authFetch={authFetch} />
          )}

          {tab === 'crm' && (
            <CRMPanel authFetch={authFetch} />
          )}

          {tab === 'crm_import' && (
            <CRMImportHub authFetch={authFetch} />
          )}

          {tab === 'contenido_30' && (
            <ContentCalendar30 authFetch={authFetch} />
          )}

          {tab === 'tiktok' && (
            <div className="space-y-8">
              <TikTokConnectPanel authFetch={authFetch} />
              <SetupGuide />
            </div>
          )}

          {tab === 'setup_guide' && <SetupGuide />}

          {tab === 'security' && (
            <Security2FAPanel authFetch={authFetch} />
          )}

          {tab === 'security_audit' && (
            <AdminSecurityAuditPage authFetch={authFetch} />
          )}

          {/* ── NUEVAS PESTAÑAS ─────────────────────────────────────── */}
          {tab === 'campaign_kanban' && (
            <CampaignKanban authFetch={authFetch} />
          )}

          {tab === 'inti_wallet' && (
            <IntiWalletPanel authFetch={authFetch} />
          )}

          {tab === 'paises_campaign' && (
            <PaisesCampaignHub authFetch={authFetch} />
          )}

          {tab === 'simple_connections' && (
            <SimpleConnectionsHub authFetch={authFetch} />
          )}

          {tab === 'health_monitor' && (
            <AynaraHealthMonitor authFetch={authFetch} />
          )}

          {tab === 'client_operations' && (
            <ClientOperationsHub authFetch={authFetch} />
          )}

          {tab === 'ai_optimization' && (
            <AIOptimizationHub authFetch={authFetch} />
          )}

          {tab === 'architecture' && (
            <AgentArchitectureHub authFetch={authFetch} />
          )}

          {tab === 'contracts' && (
            <ContractsHub authFetch={authFetch} />
          )}

          {tab === 'workspace' && (
            <WorkspaceHub authFetch={authFetch} isAdminPreview />
          )}

          {tab === 'ceo' && (
            <CompanyCEOHub authFetch={authFetch} />
          )}

          {tab === 'connections' && (
            <div className="space-y-8">
              <AdminConnectionsHub authFetch={authFetch} />
              <IntegrationsCenterHub authFetch={authFetch} />
            </div>
          )}

          {tab === 'skills' && (
            <SkillCenterHub authFetch={authFetch} />
          )}

          {tab === 'agents_dashboard' && (
            <AgentsDashboard authFetch={authFetch} onNavigateToAgent={(k) => setTab(`agente_${k}`)} />
          )}

          {tab === 'analytics' && (
            <AnalyticsDashboard authFetch={authFetch} />
          )}

          {tab === 'cron_logs' && (
            <CronLogsPanel authFetch={authFetch} />
          )}

          {tab === 'agente_ventas' && (
            <AgenteVentasPanel authFetch={authFetch} />
          )}

          {tab === 'agente_agenda' && (
            <AgenteAgendaPanel authFetch={authFetch} />
          )}

          {tab === 'agente_crm' && (
            <AgenteCRMPanel authFetch={authFetch} />
          )}

          {tab === 'agente_cobros' && (
            <AgenteCobrosPanel authFetch={authFetch} />
          )}

          {tab === 'ceo_orders' && (
            <CEOOrdersHub authFetch={authFetch} />
          )}

          {tab === 'business' && businessLines && (
            <BusinessLinesHub data={businessLines} onRefresh={loadBusinessLines} />
          )}

          {/* ===== CONTROL CENTER ===== */}
          {tab === 'control' && controlCenter && (
            <div className="space-y-6" data-testid="admin-control-center">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                <MetricCard icon={Bell} label="Campañas" value={controlCenter.metrics.social_orders_total} color="bg-primary/20 text-primary" />
                <MetricCard icon={Loader2} label="En Proceso" value={controlCenter.metrics.social_orders_in_progress} color="bg-blue-500/20 text-blue-400" />
                <MetricCard icon={CheckCircle2} label="Pendientes Aprob." value={controlCenter.metrics.pending_approvals} color="bg-yellow-500/20 text-yellow-400" />
                <MetricCard icon={ClipboardList} label="Tareas Activas" value={controlCenter.metrics.agent_tasks_in_progress} color="bg-green-500/20 text-green-400" />
              </div>

              <div className="grid xl:grid-cols-[1.2fr_0.8fr] gap-6">
                <div className="space-y-6">
                  <div className="glass-card p-6">
                    <div className="flex items-center justify-between mb-4">
                      <h3 className="text-text-heading font-heading font-semibold text-lg">Checklist Operativo</h3>
                      <button onClick={loadControlCenter} className="p-2 rounded-lg bg-card border border-border-subtle text-text-muted hover:text-primary transition-all" data-testid="refresh-control-center">
                        <RefreshCw className="w-4 h-4" />
                      </button>
                    </div>
                    <div className="space-y-3">
                      {controlCenter.checklist.map(item => (
                        <div key={item.id} className="bg-card rounded-xl border border-border-subtle p-4 flex items-start justify-between gap-4" data-testid={`control-check-${item.id}`}>
                          <div>
                            <p className="text-text-heading font-medium">{item.label}</p>
                            <p className="text-text-muted text-sm mt-1">{item.detail}</p>
                          </div>
                          <span className={`text-xs px-2 py-1 rounded-full ${item.status === 'ok' ? 'bg-green-500/20 text-green-400' : 'bg-yellow-500/20 text-yellow-400'}`}>
                            {item.status === 'ok' ? 'OK' : 'Revisar'}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="glass-card p-6">
                    <h3 className="text-text-heading font-heading font-semibold text-lg mb-4">Auditoría Reciente</h3>
                    <div className="space-y-3 max-h-[420px] overflow-y-auto" data-testid="control-audit-log">
                      {controlCenter.recent_audit.map(event => (
                        <div key={event.id} className="border border-border-subtle rounded-xl p-4 bg-card">
                          <div className="flex items-center justify-between gap-3">
                            <p className="text-text-heading text-sm font-medium">{event.title}</p>
                            <span className={`text-[10px] px-2 py-1 rounded-full ${
                              event.severity === 'error' ? 'bg-red-500/20 text-red-400' :
                              event.severity === 'warning' ? 'bg-yellow-500/20 text-yellow-400' :
                              'bg-primary/20 text-primary'
                            }`}>{event.severity}</span>
                          </div>
                          <p className="text-text-muted text-sm mt-1">{event.details}</p>
                          <p className="text-text-muted text-xs mt-2">{new Date(event.timestamp).toLocaleString('es')}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="space-y-6">
                  <div className="glass-card p-6" data-testid="voice-lab-card">
                    <h3 className="text-text-heading font-heading font-semibold text-lg mb-2">Laboratorio de Voz</h3>
                    <p className="text-text-muted text-sm mb-4">Transcribe audios internos con <span className="text-primary font-medium">whisper-1</span> para convertir notas de voz en texto operativo.</p>
                    <form onSubmit={transcribeAudio} className="space-y-4">
                      <div>
                        <label className="text-text-muted text-xs uppercase tracking-wider block mb-1">Archivo de audio</label>
                        <input type="file" accept=".mp3,.mp4,.mpeg,.mpga,.m4a,.wav,.webm"
                          onChange={e => setTranscriptFile(e.target.files?.[0] || null)}
                          className="input-kinesthetic"
                          data-testid="transcribe-audio-file" />
                      </div>
                      <div>
                        <label className="text-text-muted text-xs uppercase tracking-wider block mb-1">Idioma</label>
                        <select value={transcriptForm.language} onChange={e => setTranscriptForm({...transcriptForm, language: e.target.value})}
                          className="input-kinesthetic" data-testid="transcribe-audio-language">
                          <option value="es">Español</option>
                          <option value="en">English</option>
                        </select>
                      </div>
                      <div>
                        <label className="text-text-muted text-xs uppercase tracking-wider block mb-1">Contexto opcional</label>
                        <textarea rows={3} value={transcriptForm.prompt}
                          onChange={e => setTranscriptForm({...transcriptForm, prompt: e.target.value})}
                          className="input-kinesthetic resize-none"
                          data-testid="transcribe-audio-prompt"
                          placeholder="Ej: llamada comercial sobre automatización y ventas" />
                      </div>
                      <button type="submit" className="btn-primary w-full" disabled={transcriptionLoading} data-testid="transcribe-audio-submit">
                        {transcriptionLoading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Sparkles className="w-4 h-4" />} Transcribir audio
                      </button>
                    </form>

                    {transcriptionResult && (
                      <div className="mt-5 bg-[#0A1A3F] border border-border-subtle rounded-xl p-4" data-testid="transcription-result">
                        <div className="flex items-center justify-between gap-3 mb-2">
                          <p className="text-text-heading font-medium text-sm">{transcriptionResult.filename}</p>
                          <span className="text-xs px-2 py-1 rounded-full bg-primary/20 text-primary">{transcriptionResult.model}</span>
                        </div>
                        <p className="text-text-body text-sm whitespace-pre-wrap">{transcriptionResult.text}</p>
                      </div>
                    )}
                  </div>

                  <div className="glass-card p-6">
                    <h3 className="text-text-heading font-heading font-semibold text-lg mb-4">Últimas Transcripciones</h3>
                    <div className="space-y-3" data-testid="recent-transcriptions-list">
                      {controlCenter.recent_transcriptions.map(item => (
                        <div key={item.id} className="bg-card border border-border-subtle rounded-xl p-4">
                          <div className="flex items-center justify-between gap-3">
                            <p className="text-text-heading text-sm font-medium truncate">{item.filename}</p>
                            <span className="text-text-muted text-xs">{item.language}</span>
                          </div>
                          <p className="text-text-muted text-xs mt-2 line-clamp-3">{item.text}</p>
                        </div>
                      ))}
                      {controlCenter.recent_transcriptions.length === 0 && <p className="text-text-muted text-sm">Aún no hay transcripciones guardadas.</p>}
                    </div>
                  </div>

                  <div className="glass-card p-6" data-testid="pricing-role-config-card">
                    <h3 className="text-text-heading font-heading font-semibold text-lg mb-2">Pricing por Rol</h3>
                    <p className="text-text-muted text-sm mb-4">Define descuentos por rol comercial. La promo launch pública del 37% corre aparte y no sustituye esta configuración.</p>
                    <form onSubmit={savePricingConfig} className="space-y-3">
                      {[
                        ['publico', 'Público'],
                        ['agencia', 'Agencia'],
                        ['partner', 'Partner'],
                        ['asociado', 'Asociado']
                      ].map(([key, label]) => (
                        <div key={key}>
                          <label className="text-text-muted text-xs uppercase tracking-wider block mb-1">{label}</label>
                          <input type="number" min="0" max="90" value={pricingForm[key]}
                            onChange={e => setPricingForm({ ...pricingForm, [key]: e.target.value })}
                            className="input-kinesthetic" data-testid={`pricing-role-${key}-input`} />
                        </div>
                      ))}
                      <button type="submit" className="btn-primary w-full" data-testid="save-pricing-config">
                        <Shield className="w-4 h-4" /> Guardar pricing
                      </button>
                    </form>
                    {pricingConfig && (
                      <div className="mt-4 text-xs text-text-muted space-y-1">
                        <p>Público: {pricingConfig.publico?.discount_percent}% · Agencia: {pricingConfig.agencia?.discount_percent}%</p>
                        <p>Partner: {pricingConfig.partner?.discount_percent}% · Asociado: {pricingConfig.asociado?.discount_percent}%</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* ===== ANALYTICS ===== */}
          {tab === 'analytics' && analytics && (
            <div className="space-y-6" data-testid="admin-analytics">
              <div className="glass-card p-6">
                <h3 className="text-text-heading font-heading font-semibold text-lg mb-4">Conversaciones por Día</h3>
                <ResponsiveContainer width="100%" height={300}>
                  <AreaChart data={analytics.daily_chats}>
                    <defs>
                      <linearGradient id="chatGrad2" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="5%" stopColor="#00E5FF" stopOpacity={0.3} />
                        <stop offset="95%" stopColor="#00E5FF" stopOpacity={0} />
                      </linearGradient>
                    </defs>
                    <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)" />
                    <XAxis dataKey="date" tick={{ fill: '#64748B', fontSize: 12 }} tickFormatter={v => v.slice(5)} />
                    <YAxis tick={{ fill: '#64748B', fontSize: 12 }} />
                    <Tooltip content={<CustomTooltip />} />
                    <Area type="monotone" dataKey="count" stroke="#00E5FF" fill="url(#chatGrad2)" strokeWidth={2} />
                  </AreaChart>
                </ResponsiveContainer>
              </div>

              <div className="grid md:grid-cols-2 gap-6">
                <div className="glass-card p-6">
                  <h3 className="text-text-heading font-heading font-semibold text-lg mb-4">Distribución por Agente</h3>
                  <ResponsiveContainer width="100%" height={280}>
                    <PieChart>
                      <Pie data={analytics.agent_distribution} cx="50%" cy="50%" innerRadius={60} outerRadius={100}
                        dataKey="count" nameKey="agent" paddingAngle={3}>
                        {analytics.agent_distribution.map((_, i) => (
                          <Cell key={i} fill={CHART_COLORS[i % CHART_COLORS.length]} />
                        ))}
                      </Pie>
                      <Tooltip content={({ active, payload }) => active && payload?.length ? (
                        <div className="bg-[#0A1A3F] border border-[rgba(255,255,255,0.1)] rounded-lg px-3 py-2">
                          <p className="text-white text-xs">{payload[0].name}</p>
                          <p className="text-[#00E5FF] font-bold">{payload[0].value}</p>
                        </div>
                      ) : null} />
                    </PieChart>
                  </ResponsiveContainer>
                  <div className="flex flex-wrap gap-3 mt-3">
                    {analytics.agent_distribution.map((a, i) => (
                      <span key={i} className="flex items-center gap-1.5 text-sm text-text-body">
                        <span className="w-3 h-3 rounded-full" style={{ background: CHART_COLORS[i % CHART_COLORS.length] }} />
                        {a.agent}: <span className="font-bold text-text-heading">{a.count}</span>
                      </span>
                    ))}
                  </div>
                </div>

                <div className="glass-card p-6">
                  <h3 className="text-text-heading font-heading font-semibold text-lg mb-4">Leads por Día</h3>
                  <ResponsiveContainer width="100%" height={280}>
                    <BarChart data={analytics.daily_leads}>
                      <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)" />
                      <XAxis dataKey="date" tick={{ fill: '#64748B', fontSize: 11 }} tickFormatter={v => v.slice(5)} />
                      <YAxis tick={{ fill: '#64748B', fontSize: 11 }} />
                      <Tooltip content={<CustomTooltip />} />
                      <Bar dataKey="count" fill="#4361EE" radius={[4, 4, 0, 0]} />
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-6">
                <div className="glass-card p-6">
                  <h3 className="text-text-heading font-heading font-semibold text-lg mb-4">Citas por Día</h3>
                  <ResponsiveContainer width="100%" height={250}>
                    <BarChart data={analytics.daily_bookings}>
                      <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)" />
                      <XAxis dataKey="date" tick={{ fill: '#64748B', fontSize: 11 }} />
                      <YAxis tick={{ fill: '#64748B', fontSize: 11 }} />
                      <Tooltip content={<CustomTooltip />} />
                      <Bar dataKey="count" fill="#F72585" radius={[4, 4, 0, 0]} />
                    </BarChart>
                  </ResponsiveContainer>
                </div>

                <div className="glass-card p-6">
                  <h3 className="text-text-heading font-heading font-semibold text-lg mb-4">Usuarios por Rol</h3>
                  <ResponsiveContainer width="100%" height={250}>
                    <PieChart>
                      <Pie data={analytics.users_by_role} cx="50%" cy="50%" innerRadius={50} outerRadius={80}
                        dataKey="count" nameKey="role" paddingAngle={5}>
                        {analytics.users_by_role.map((_, i) => (
                          <Cell key={i} fill={CHART_COLORS[i % CHART_COLORS.length]} />
                        ))}
                      </Pie>
                      <Tooltip content={({ active, payload }) => active && payload?.length ? (
                        <div className="bg-[#0A1A3F] border border-[rgba(255,255,255,0.1)] rounded-lg px-3 py-2">
                          <p className="text-white text-xs">{ROLE_LABELS[payload[0].name] || payload[0].name}</p>
                          <p className="text-[#00E5FF] font-bold">{payload[0].value}</p>
                        </div>
                      ) : null} />
                    </PieChart>
                  </ResponsiveContainer>
                  <div className="flex flex-wrap gap-3 mt-2">
                    {analytics.users_by_role.map((u, i) => (
                      <span key={i} className="flex items-center gap-1.5 text-sm text-text-body">
                        <span className="w-3 h-3 rounded-full" style={{ background: CHART_COLORS[i % CHART_COLORS.length] }} />
                        {ROLE_LABELS[u.role] || u.role}: <span className="font-bold text-text-heading">{u.count}</span>
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* ===== AGENTS ===== */}
          {tab === 'agents' && (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="admin-agents">
              {agents.map((a) => {
                const Icon = AGENT_ICONS[a.agent_type] || Sparkles;
                return (
                  <motion.div key={a.agent_type} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}
                    className={`glass-card p-5 relative transition-all ${!a.active ? 'opacity-50' : ''}`}>
                    <div className="flex items-start justify-between mb-3">
                      <div className="flex items-center gap-3">
                        <div className={`w-14 h-14 rounded-xl flex items-center justify-center ${a.active ? 'bg-primary/15' : 'bg-gray-500/15'}`}>
                          <Icon className={`w-7 h-7 ${a.active ? 'text-primary' : 'text-gray-500'}`} />
                        </div>
                        <div>
                          <h3 className="text-text-heading font-heading font-semibold text-base">{a.name}</h3>
                          <span className="text-text-muted text-sm">{a.agent_type}</span>
                        </div>
                      </div>
                      <button onClick={() => toggleAgent(a.agent_type, a.active)}
                        className={`p-2 rounded-lg transition-all ${a.active ? 'bg-green-500/20 text-green-400 hover:bg-green-500/30' : 'bg-red-500/20 text-red-400 hover:bg-red-500/30'}`}
                        data-testid={`toggle-agent-${a.agent_type}`}>
                        {a.active ? <Power className="w-4 h-4" /> : <PowerOff className="w-4 h-4" />}
                      </button>
                    </div>
                    <p className="text-text-muted text-sm mb-3">{a.description}</p>
                    <div className="flex items-center justify-between pt-3 border-t border-border-subtle">
                      <span className="text-primary text-lg font-bold font-data">{a.total_conversations}</span>
                      <span className="text-text-muted text-sm">conversaciones</span>
                    </div>
                  </motion.div>
                );
              })}
            </div>
          )}

          {/* ===== TEAM ===== */}
          {tab === 'team' && (
            <div className="space-y-4" data-testid="admin-team">
              <div className="flex flex-wrap items-start justify-between gap-4">
                <div>
                  <h3 className="text-text-heading font-heading text-lg font-semibold">Partners y Asociados</h3>
                  <p className="text-text-muted text-sm mt-1">Crea colaboradores, define su rol y deja claro qué agentes pueden tocar sin perderte en tablas largas.</p>
                </div>
                <div className="flex flex-wrap gap-2">
                  <button onClick={() => navigate('/admin/clientes')} className="btn-secondary text-sm py-2 px-4" data-testid="open-client-provisioning-btn">
                    <Building2 className="w-4 h-4" /> Cliente express
                  </button>
                  <button onClick={() => setShowCreateUser(true)} className="btn-primary text-sm py-2 px-4" data-testid="create-user-btn">
                    <UserPlus className="w-4 h-4" /> Nuevo
                  </button>
                </div>
              </div>

              <AnimatePresence>
                {showCreateUser && (
                  <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
                    className="fixed inset-0 z-[9999] bg-black/60 flex items-center justify-center p-4"
                    onClick={() => setShowCreateUser(false)}>
                    <motion.div initial={{ scale: 0.95 }} animate={{ scale: 1 }} exit={{ scale: 0.95 }}
                      className="glass-card p-6 w-full max-w-4xl max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-testid="create-user-modal">
                      <div className="flex items-center justify-between mb-4 gap-4">
                        <div>
                          <h3 className="text-text-heading font-heading font-semibold text-lg">Nuevo Usuario</h3>
                          <p className="text-text-muted text-sm mt-1">Deja claro el rol, la empresa y qué agentes puede supervisar para que el alta sea rápida y sin errores.</p>
                        </div>
                        <button onClick={() => setShowCreateUser(false)} className="text-text-muted hover:text-white p-1" data-testid="close-create-user-modal"><X className="w-5 h-5" /></button>
                      </div>
                      <form onSubmit={createUser} className="grid gap-6 lg:grid-cols-[1.15fr_0.85fr]">
                        <div className="space-y-4">
                          <div className="grid gap-4 md:grid-cols-2">
                            <input type="text" placeholder="Nombre completo" required value={newUser.nombre}
                              onChange={e => setNewUser({...newUser, nombre: e.target.value})} className="input-kinesthetic" data-testid="new-user-name" />
                            <input type="email" placeholder="Email" required value={newUser.email}
                              onChange={e => setNewUser({...newUser, email: e.target.value})} className="input-kinesthetic" data-testid="new-user-email" />
                          </div>
                          <div className="grid gap-4 md:grid-cols-2">
                            <PasswordInput placeholder="Contraseña" required minLength={6} value={newUser.password}
                              onChange={e => setNewUser({...newUser, password: e.target.value})} inputClassName="input-kinesthetic" testId="new-user-password" toggleTestId="new-user-password-visibility-toggle" />
                            <input type="text" placeholder="Empresa (opcional)" value={newUser.empresa}
                              onChange={e => setNewUser({...newUser, empresa: e.target.value})} className="input-kinesthetic" data-testid="new-user-company" />
                          </div>
                          <div>
                            <label className="text-text-muted text-xs uppercase tracking-wider block mb-2 font-body">Rol</label>
                            <div className="flex flex-wrap gap-2" data-testid="new-user-role-options">
                              {['agencia', 'partner', 'asociado', 'user', 'doctora', 'enfermera', 'administradora', 'community_manager'].map(r => (
                                <button key={r} type="button" onClick={() => setNewUser({...newUser, role: r})}
                                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                                    newUser.role === r ? 'bg-primary text-[#0A1A3F]' : 'bg-card border border-border-subtle text-text-muted hover:border-primary/40'
                                  }`} data-testid={`new-user-role-${r}`}>{ROLE_LABELS[r]}</button>
                              ))}
                            </div>
                          </div>
                          {['agencia', 'partner', 'asociado'].includes(newUser.role) && (
                            <div className="space-y-4" data-testid="partner-country-configurator">
                              <label className="text-text-muted text-xs uppercase tracking-wider block font-body">Exclusividad por país</label>
                              <div className="rounded-[20px] border border-border-subtle bg-card/40 p-4 space-y-3">
                                <label className="flex items-center gap-3 text-sm text-text-body" data-testid="country-exclusive-toggle-row">
                                  <input
                                    type="checkbox"
                                    checked={newUser.country_exclusivity_enabled}
                                    onChange={(e) => setNewUser({ ...newUser, country_exclusivity_enabled: e.target.checked })}
                                    data-testid="country-exclusive-toggle"
                                  />
                                  Reservar países en exclusiva para este partner
                                </label>
                                <input
                                  type="text"
                                  placeholder="Ej. España, México, Colombia"
                                  value={(newUser.partner_countries || []).join(', ')}
                                  onChange={(e) => setNewUser({
                                    ...newUser,
                                    partner_countries: e.target.value.split(',').map((item) => item.trim()).filter(Boolean)
                                  })}
                                  className="input-kinesthetic"
                                  data-testid="new-user-country-input"
                                />
                                <p className="text-xs text-text-muted">Se usarán para enrutar leads automáticamente cuando el formulario llegue con país.</p>
                              </div>
                            </div>
                          )}
                          {agents.length > 0 && (
                            <div>
                              <label className="text-text-muted text-xs uppercase tracking-wider block mb-2 font-body">Agentes asignados</label>
                              <div className="flex flex-wrap gap-2" data-testid="new-user-agent-options">
                                {agents.map(a => (
                                  <button key={a.agent_type} type="button"
                                    onClick={() => {
                                      const current = newUser.assigned_agents || [];
                                      setNewUser({...newUser, assigned_agents: current.includes(a.agent_type)
                                        ? current.filter(x => x !== a.agent_type)
                                        : [...current, a.agent_type]
                                      });
                                    }}
                                    className={`px-3 py-1.5 rounded-lg text-xs font-medium transition-all ${
                                      (newUser.assigned_agents || []).includes(a.agent_type)
                                        ? 'bg-primary/20 text-primary border border-primary/40'
                                        : 'bg-card border border-border-subtle text-text-muted hover:border-primary/30'
                                    }`} data-testid={`new-user-agent-${a.agent_type.toLowerCase()}`}>{a.agent_type}</button>
                                ))}
                              </div>
                            </div>
                          )}
                        </div>

                        <div className="space-y-4">
                          <div className="rounded-[24px] border border-primary/15 bg-primary/5 p-5" data-testid="new-user-summary-card">
                            <p className="text-[10px] uppercase tracking-[0.18em] text-text-muted">Resumen del alta</p>
                            <p className="mt-3 text-text-heading font-semibold text-lg">{ROLE_LABELS[newUser.role]}</p>
                            <p className="mt-2 text-sm text-text-body">{newUser.empresa || 'Sin empresa especificada todavía'}</p>
                            <p className="mt-2 text-xs text-primary" data-testid="new-user-client-id-preview">Client ID automático: {['doctora', 'enfermera', 'administradora', 'community_manager'].includes(newUser.role) ? 'NEURALIA-CLINIC-001' : 'Se asigna al guardar'}</p>
                            {['agencia', 'partner', 'asociado'].includes(newUser.role) && (
                              <p className="mt-3 text-xs text-text-body" data-testid="new-user-country-summary">Países: {(newUser.partner_countries || []).length ? newUser.partner_countries.join(', ') : 'Sin países definidos'}</p>
                            )}
                            {['agencia', 'partner', 'asociado'].includes(newUser.role) && newUser.country_exclusivity_enabled && (
                              <p className="mt-2 text-xs text-primary" data-testid="new-user-exclusive-summary">Exclusividad activa para routing automático</p>
                            )}
                            <p className="mt-4 text-xs text-text-muted">Agentes visibles: {(newUser.assigned_agents || []).length > 0 ? newUser.assigned_agents.join(', ') : 'Todos'}</p>
                          </div>
                          <div className="rounded-[24px] border border-border-subtle bg-card/40 p-5" data-testid="new-user-help-card">
                            <p className="text-[10px] uppercase tracking-[0.18em] text-text-muted">Cómo usarlo mejor</p>
                            <div className="mt-3 space-y-2 text-sm text-text-body">
                              <p>1. Usa <strong>Partner</strong> para colaboradores estratégicos con acceso continuo.</p>
                              <p>2. Usa <strong>Asociado</strong> cuando necesite ver menos y operar más acotado.</p>
                              <p>3. Limita agentes si quieres una experiencia más simple y segura.</p>
                            </div>
                          </div>
                          <div className="flex flex-col sm:flex-row gap-3">
                            <button type="button" onClick={() => setShowCreateUser(false)} className="btn-secondary flex-1 justify-center" data-testid="cancel-create-user">
                              Cancelar
                            </button>
                            <button type="submit" className="btn-primary flex-1 justify-center" data-testid="submit-create-user">
                              <UserPlus className="w-4 h-4" /> Crear {ROLE_LABELS[newUser.role]}
                            </button>
                          </div>
                        </div>
                      </form>
                    </motion.div>
                  </motion.div>
                )}
              </AnimatePresence>

              <div className="grid gap-4 md:grid-cols-3 xl:grid-cols-4" data-testid="team-mobile-cards">
                {teamUsers.map((u) => (
                  <div key={`card-${u.id}`} className="glass-card p-5 md:hidden" data-testid={`team-user-card-${u.id}`}>
                    <div className="flex items-start justify-between gap-3">
                      <div>
                        <p className="text-text-heading font-medium">{u.nombre}</p>
                        <p className="text-text-muted text-sm break-all">{u.email}</p>
                        <p className="text-text-body text-sm mt-2">{u.empresa || 'Sin empresa'}</p>
                        <p className="text-primary text-xs mt-2" data-testid={`team-user-client-id-mobile-${u.id}`}>{u.client_id || 'Client ID pendiente'}</p>
                        <p className="text-text-muted text-[11px] mt-1" data-testid={`team-user-last-login-mobile-${u.id}`}>{u.last_login_at ? `Último acceso ${new Date(u.last_login_at).toLocaleString('es-ES')}` : 'Sin accesos registrados'}</p>
                      </div>
                      <span className={`text-xs px-2 py-1 rounded-full ${ROLE_COLORS[u.role] || ROLE_COLORS.user}`}>{ROLE_LABELS[u.role] || u.role}</span>
                    </div>
                    <div className="mt-4 flex flex-wrap gap-2">{(u.assigned_agents || []).length > 0 ? (u.assigned_agents || []).map(a => <span key={a} className="text-xs px-2 py-0.5 rounded-full bg-primary/10 text-primary">{a}</span>) : <span className="text-text-muted text-xs">Todos los agentes</span>}</div>
                    <div className="mt-4 flex items-center justify-between gap-3">
                      <span className={`text-xs px-2 py-1 rounded-full ${u.active !== false ? 'bg-green-500/20 text-green-400' : 'bg-red-500/20 text-red-400'}`}>{u.active !== false ? 'Activo' : 'Inactivo'}</span>
                      {u.role !== 'admin' && (
                        <div className="flex items-center gap-2">
                          <button onClick={() => toggleUserActive(u.id, u.active !== false)} className={`p-1.5 rounded-lg transition-all ${u.active !== false ? 'hover:bg-yellow-500/20 text-yellow-400' : 'hover:bg-green-500/20 text-green-400'}`} title={u.active !== false ? 'Desactivar' : 'Activar'} data-testid={`toggle-user-mobile-${u.id}`}>
                            {u.active !== false ? <PowerOff className="w-4 h-4" /> : <Power className="w-4 h-4" />}
                          </button>
                          <button onClick={() => deleteUser(u.id, u.nombre)} className="p-1.5 rounded-lg hover:bg-red-500/20 text-red-400 transition-all" title="Eliminar" data-testid={`delete-user-mobile-${u.id}`}>
                            <Trash2 className="w-4 h-4" />
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              <div className="glass-card overflow-hidden hidden md:block">
                <div className="overflow-x-auto">
                  <table className="w-full text-base">
                    <thead>
                      <tr className="border-b border-border-subtle">
                        <th className="text-left p-4 text-text-muted font-medium">Usuario</th>
                        <th className="text-left p-4 text-text-muted font-medium">Client ID</th>
                        <th className="text-left p-4 text-text-muted font-medium">Empresa</th>
                        <th className="text-left p-4 text-text-muted font-medium">Rol</th>
                        <th className="text-left p-4 text-text-muted font-medium">Agentes</th>
                        <th className="text-left p-4 text-text-muted font-medium hidden xl:table-cell">Países</th>
                        <th className="text-left p-4 text-text-muted font-medium">Estado</th>
                        <th className="text-left p-4 text-text-muted font-medium hidden xl:table-cell">Último acceso</th>
                        <th className="text-right p-4 text-text-muted font-medium">Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {teamUsers.map((u) => (
                        <tr key={u.id} className="border-b border-border-subtle/50 hover:bg-card-hover transition-colors">
                          <td className="p-4">
                            <p className="text-text-heading font-medium">{u.nombre}</p>
                            <p className="text-text-muted text-sm">{u.email}</p>
                          </td>
                          <td className="p-4 text-primary text-sm" data-testid={`team-user-client-id-${u.id}`}>{u.client_id || 'Pendiente'}</td>
                          <td className="p-4 text-text-body">{u.empresa || '-'}</td>
                          <td className="p-4">
                            {u.role === 'admin' ? (
                              <span className={`text-xs px-2 py-1 rounded-full ${ROLE_COLORS.admin}`}>{ROLE_LABELS.admin}</span>
                            ) : (
                              <select value={u.role} onChange={e => updateUserRole(u.id, e.target.value)}
                                className="bg-card border border-border-subtle rounded-lg px-2 py-1 text-text-heading text-sm outline-none focus:border-primary"
                                data-testid={`role-select-${u.id}`}>
                                <option value="agencia">Agencia</option>
                                <option value="partner">Partner</option>
                                <option value="asociado">Asociado</option>
                                <option value="user">Usuario</option>
                              </select>
                            )}
                          </td>
                          <td className="p-4">
                            <div className="flex flex-wrap gap-1">
                              {(u.assigned_agents || []).map(a => (
                                <span key={a} className="text-xs px-2 py-0.5 rounded-full bg-primary/10 text-primary">{a}</span>
                              ))}
                              {(!u.assigned_agents || u.assigned_agents.length === 0) && <span className="text-text-muted text-xs">Todos</span>}
                            </div>
                          </td>
                          <td className="p-4 hidden xl:table-cell">
                            <div className="flex flex-wrap gap-1" data-testid={`team-user-countries-${u.id}`}>
                              {(u.partner_countries || []).length > 0 ? (u.partner_countries || []).map((country) => (
                                <span key={country} className="text-xs px-2 py-0.5 rounded-full bg-secondary/10 text-secondary">{country}</span>
                              )) : <span className="text-text-muted text-xs">—</span>}
                            </div>
                            {u.country_exclusivity_enabled && <p className="mt-1 text-[11px] text-primary">Exclusivo</p>}
                          </td>
                          <td className="p-4">
                            <span className={`text-xs px-2 py-1 rounded-full ${u.active !== false ? 'bg-green-500/20 text-green-400' : 'bg-red-500/20 text-red-400'}`}>
                              {u.active !== false ? 'Activo' : 'Inactivo'}
                            </span>
                          </td>
                          <td className="p-4 text-text-body text-sm hidden xl:table-cell" data-testid={`team-user-last-login-${u.id}`}>{u.last_login_at ? new Date(u.last_login_at).toLocaleString('es-ES') : '—'}</td>
                          <td className="p-4 text-right">
                            {u.role !== 'admin' && (
                              <div className="flex items-center justify-end gap-2">
                                <button onClick={() => toggleUserActive(u.id, u.active !== false)}
                                  className={`p-1.5 rounded-lg transition-all ${u.active !== false ? 'hover:bg-yellow-500/20 text-yellow-400' : 'hover:bg-green-500/20 text-green-400'}`}
                                  title={u.active !== false ? 'Desactivar' : 'Activar'}>
                                  {u.active !== false ? <PowerOff className="w-4 h-4" /> : <Power className="w-4 h-4" />}
                                </button>
                                <button onClick={() => deleteUser(u.id, u.nombre)} className="p-1.5 rounded-lg hover:bg-red-500/20 text-red-400 transition-all" title="Eliminar">
                                  <Trash2 className="w-4 h-4" />
                                </button>
                              </div>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {teamUsers.length === 0 && <p className="p-8 text-center text-text-muted">No hay usuarios</p>}
              </div>
            </div>
          )}

          {/* ===== LEADS ===== */}
          {tab === 'leads' && (
            <div className="space-y-6">
              <TerritoryExecutiveMap
                title="Mapa ejecutivo territorial"
                subtitle="Cruza países exclusivos con captación real para detectar cobertura, saturación y huecos comerciales en segundos."
                items={buildAdminTerritoryMapItems(teamUsers, leads)}
                testId="admin-territory-executive-map"
              />

              <div className="glass-card overflow-hidden" data-testid="admin-leads-table">
                <div className="overflow-x-auto">
                  <table className="w-full text-base">
                    <thead>
                      <tr className="border-b border-border-subtle">
                        <th className="text-left p-4 text-text-muted font-medium">Nombre</th>
                        <th className="text-left p-4 text-text-muted font-medium">Email</th>
                        <th className="text-left p-4 text-text-muted font-medium hidden md:table-cell">Empresa</th>
                        <th className="text-left p-4 text-text-muted font-medium hidden lg:table-cell">País / Routing</th>
                        <th className="text-left p-4 text-text-muted font-medium hidden xl:table-cell">Mensaje</th>
                        <th className="text-left p-4 text-text-muted font-medium">Fecha</th>
                      </tr>
                    </thead>
                    <tbody>
                      {leads.map((l, i) => (
                        <tr key={i} className="border-b border-border-subtle/50 hover:bg-card-hover transition-colors">
                          <td className="p-4 text-text-heading">{l.nombre}</td>
                          <td className="p-4 text-primary">{l.email}</td>
                          <td className="p-4 text-text-body hidden md:table-cell">{l.empresa || '-'}</td>
                          <td className="p-4 text-text-body hidden lg:table-cell">
                            <div className="space-y-1" data-testid={`lead-routing-${l.id || i}`}>
                              <p>{l.country || 'Sin país'}</p>
                              <p className="text-xs text-primary">{l.assigned_partner_name ? `Asignado a ${l.assigned_partner_name}` : 'Sin partner asignado'}</p>
                            </div>
                          </td>
                          <td className="p-4 text-text-body hidden xl:table-cell max-w-xs truncate">{l.mensaje}</td>
                          <td className="p-4 text-text-muted">{new Date(l.timestamp).toLocaleDateString('es')}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {leads.length === 0 && <p className="p-8 text-center text-text-muted">No hay leads</p>}
              </div>
            </div>
          )}

          {/* ===== CONVERSATIONS ===== */}
          {tab === 'conversations' && !selectedConvo && (
            <div className="space-y-3" data-testid="admin-conversations-list">
              {conversations.map((c, i) => {
                const AgentIcon = AGENT_ICONS[c.last_agent] || Sparkles;
                return (
                  <motion.button key={i} initial={{ opacity: 0 }} animate={{ opacity: 1 }}
                    onClick={() => loadConvoDetail(c.session_id)}
                    className="w-full glass-card p-4 flex items-center justify-between hover:border-primary/40 transition-all text-left">
                    <div className="flex items-center gap-3 min-w-0">
                      <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                        <AgentIcon className="w-5 h-5 text-primary" />
                      </div>
                      <div className="min-w-0">
                        <p className="text-text-heading text-base font-medium truncate">Sesión: {c.session_id.slice(0, 12)}...</p>
                        <p className="text-text-muted text-sm">{c.count} msgs · {c.last_agent || 'GENERAL'}</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-2 flex-shrink-0">
                      <span className="text-text-muted text-sm">{c.last_message?.slice(0, 10)}</span>
                      <ChevronRight className="w-4 h-4 text-text-muted" />
                    </div>
                  </motion.button>
                );
              })}
              {conversations.length === 0 && <p className="p-8 text-center text-text-muted">No hay conversaciones</p>}
            </div>
          )}

          {tab === 'conversations' && selectedConvo && (
            <div data-testid="admin-conversation-detail">
              <button onClick={() => setSelectedConvo(null)} className="text-primary text-sm mb-4 hover:underline flex items-center gap-1">
                <ChevronRight className="w-4 h-4 rotate-180" /> Volver
              </button>
              <div className="glass-card p-6 space-y-4 max-h-[60vh] overflow-y-auto">
                {convoMessages.map((m, i) => (
                  <div key={i} className="space-y-2">
                    <div className="flex justify-end">
                      <div className="bg-primary/20 text-text-heading rounded-2xl rounded-br-sm px-4 py-2 max-w-[70%] text-base">{m.user_message}</div>
                    </div>
                    <div className="flex justify-start">
                      <div className="bg-card border border-border-subtle rounded-2xl rounded-bl-sm px-4 py-2 max-w-[70%] text-base text-text-body">
                        {m.agent_type && <span className="text-primary text-xs font-medium block mb-1">{m.agent_type}</span>}
                        {m.assistant_response}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* ===== BOOKINGS ===== */}
          {tab === 'sales_panel' && <SalesPanelHub authFetch={authFetch} />}
          {tab === 'calendario' && <AdminCalendarHub authFetch={authFetch} />}
          {tab === 'contratos' && <AdminContractsHub authFetch={authFetch} />}
          {tab === 'portal' && <AdminPortalHub authFetch={authFetch} />}
          {tab === 'tesix' && (
            <div className="space-y-3" data-testid="admin-tesix-hub">
              <div className="flex items-center justify-between">
                <p className="text-sm text-gray-400">Neuralia369Tesix ahora vive solo aquí dentro del admin (retirado de la web pública).</p>
                <a href="/neuralia369tesix" target="_blank" rel="noreferrer" className="rounded-full bg-[#00d4ff] px-4 py-2 text-xs font-bold text-[#02040a]" data-testid="admin-tesix-open">Abrir en pestaña nueva ↗</a>
              </div>
              <iframe src="/neuralia369tesix" title="Neuralia369Tesix" className="h-[75vh] w-full rounded-2xl border border-white/10 bg-white" data-testid="admin-tesix-iframe" />
            </div>
          )}

          {tab === 'aynara_calls' && <AynaraCallsHub authFetch={authFetch} />}

          {tab === 'email_log' && <EmailLogHub authFetch={authFetch} />}

          {tab === 'campaign_kit' && <CampaignKitHub />}

          {tab === 'bookings' && (
            <div className="space-y-6">
              <BookingConsultantsManager authFetch={authFetch} />

              <div className="glass-card overflow-hidden" data-testid="admin-bookings-table">
                <div className="overflow-x-auto">
                  <table className="w-full text-base">
                    <thead>
                      <tr className="border-b border-border-subtle">
                        <th className="text-left p-4 text-text-muted font-medium">Nombre</th>
                        <th className="text-left p-4 text-text-muted font-medium">Email</th>
                        <th className="text-left p-4 text-text-muted font-medium">Fecha</th>
                        <th className="text-left p-4 text-text-muted font-medium">Hora</th>
                        <th className="text-left p-4 text-text-muted font-medium hidden md:table-cell">Tipo</th>
                        <th className="text-left p-4 text-text-muted font-medium hidden lg:table-cell">Consultor</th>
                        <th className="text-left p-4 text-text-muted font-medium">Estado</th>
                      </tr>
                    </thead>
                    <tbody>
                      {bookings.map((b, i) => (
                        <tr key={i} className="border-b border-border-subtle/50 hover:bg-card-hover transition-colors">
                          <td className="p-4 text-text-heading">{b.nombre}</td>
                          <td className="p-4 text-primary">{b.email}</td>
                          <td className="p-4 text-text-body">{b.fecha}</td>
                          <td className="p-4 text-text-body">{b.hora}</td>
                          <td className="p-4 text-text-body hidden md:table-cell">{b.tipo_nombre || b.tipo}</td>
                          <td className="p-4 text-text-body hidden lg:table-cell" data-testid={`admin-booking-consultant-${b.id || i}`}>
                            {b.consultant_name ? (
                              <div>
                                <p className="text-text-heading font-medium">{b.consultant_name}</p>
                                <p className="text-xs text-text-muted">{b.booking_mode === 'human_consultant' ? 'Asignación humana automática' : 'Reserva automática'}</p>
                              </div>
                            ) : (
                              <span className="text-text-muted">Auto</span>
                            )}
                          </td>
                          <td className="p-4">
                            <span className={`text-xs px-2 py-1 rounded-full ${b.status === 'confirmed' ? 'bg-green-500/20 text-green-400' : 'bg-yellow-500/20 text-yellow-400'}`}>
                              {b.status === 'confirmed' ? 'Confirmada' : b.status}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {bookings.length === 0 && <p className="p-8 text-center text-text-muted">No hay citas</p>}
              </div>
            </div>
          )}

          {/* ===== SERVICE BRIEFINGS ===== */}
          {tab === 'briefings' && (
            <div className="space-y-4" data-testid="admin-service-briefings">
              <div className="flex items-center justify-between gap-4 flex-wrap">
                <div>
                  <h3 className="text-text-heading font-heading text-lg font-semibold">Briefings post-pago</h3>
                  <p className="text-text-muted text-sm mt-1">Información operativa enviada por clientes tras completar su compra.</p>
                </div>
                <div className="flex items-center gap-2">
                  <button onClick={backfillPostConsultingWorkflows} className="btn-secondary text-sm py-2 px-4" data-testid="backfill-post-consulting-workflows">
                    <Rocket className="w-4 h-4" /> Activar workflows pendientes
                  </button>
                  <button onClick={loadServiceIntakes} className="p-2 rounded-lg bg-card border border-border-subtle text-text-muted hover:text-primary transition-all" data-testid="refresh-service-briefings">
                    <RefreshCw className="w-4 h-4" />
                  </button>
                </div>
              </div>

              {workflowDetailLoading && (
                <div className="glass-card p-6 text-center text-text-muted" data-testid="post-consulting-workflow-loading">
                  Cargando informe completo...
                </div>
              )}

              {selectedWorkflowDetail?.workflow && (
                <div className="glass-card p-6 space-y-5" data-testid="post-consulting-workflow-detail">
                  <div className="flex flex-wrap items-start justify-between gap-4">
                    <div>
                      <p className="text-[10px] uppercase tracking-[0.18em] text-text-muted">Informe multiagente</p>
                      <h4 className="mt-2 text-2xl font-semibold text-text-heading">{selectedWorkflowDetail.workflow.company_name}</h4>
                      <p className="mt-2 text-sm text-text-body">{selectedWorkflowDetail.workflow.executive_summary || selectedWorkflowDetail.workflow.report_excerpt || 'El informe aún se está elaborando.'}</p>
                    </div>
                    <button onClick={closePostConsultingWorkflowDetail} className="btn-secondary text-sm py-2 px-4" data-testid="close-post-consulting-workflow-detail">
                      <X className="w-4 h-4" /> Cerrar
                    </button>
                  </div>

                  <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-4 text-sm">
                    <div className="rounded-[20px] border border-border-subtle bg-card/40 p-4" data-testid="post-consulting-detail-status">
                      <p className="text-[10px] uppercase tracking-[0.18em] text-text-muted">Estado</p>
                      <p className="mt-2 text-text-heading font-semibold">{selectedWorkflowDetail.workflow.status}</p>
                    </div>
                    <div className="rounded-[20px] border border-border-subtle bg-card/40 p-4" data-testid="post-consulting-detail-task-status">
                      <p className="text-[10px] uppercase tracking-[0.18em] text-text-muted">Task</p>
                      <p className="mt-2 text-text-heading font-semibold">{selectedWorkflowDetail.workflow.linked_task_status || 'sin task'}</p>
                    </div>
                    <div className="rounded-[20px] border border-border-subtle bg-card/40 p-4" data-testid="post-consulting-detail-focuses">
                      <p className="text-[10px] uppercase tracking-[0.18em] text-text-muted">Focos</p>
                      <p className="mt-2 text-text-heading font-semibold">{(selectedWorkflowDetail.workflow.focus_areas || []).length}</p>
                    </div>
                    <div className="rounded-[20px] border border-border-subtle bg-card/40 p-4" data-testid="post-consulting-detail-agents-count">
                      <p className="text-[10px] uppercase tracking-[0.18em] text-text-muted">Agentes activos</p>
                      <p className="mt-2 text-text-heading font-semibold">{(selectedWorkflowDetail.workflow.agent_outputs || []).length || (selectedWorkflowDetail.workflow.selected_agents || []).length}</p>
                    </div>
                  </div>

                  {selectedWorkflowDetail.ceo_order && (
                    <div className="rounded-[24px] border border-primary/15 bg-primary/5 p-4" data-testid="post-consulting-detail-ceo-order">
                      <p className="text-[10px] uppercase tracking-[0.18em] text-text-muted">Orden CEO sugerida</p>
                      <div className="mt-2 flex flex-wrap items-start justify-between gap-3">
                        <div>
                          <h5 className="text-lg font-semibold text-text-heading">{selectedWorkflowDetail.ceo_order.title}</h5>
                          <p className="mt-2 text-sm text-text-body whitespace-pre-wrap">{selectedWorkflowDetail.ceo_order.instruction}</p>
                        </div>
                        <span className="rounded-full border border-primary/20 bg-primary/10 px-3 py-1 text-[10px] uppercase tracking-[0.16em] text-primary">{selectedWorkflowDetail.ceo_order.status}</span>
                      </div>
                    </div>
                  )}

                  {!selectedWorkflowDetail.ceo_order && (
                    <div className="rounded-[24px] border border-dashed border-border-subtle bg-card/30 p-4 flex flex-wrap items-center justify-between gap-3" data-testid="post-consulting-detail-sync-ceo-order-card">
                      <div>
                        <p className="text-text-heading font-semibold">Generar orden CEO sugerida</p>
                        <p className="text-sm text-text-body mt-1">Si el workflow ya tiene resumen ejecutivo, podemos crear la orden CEO manual para cerrar el circuito.</p>
                      </div>
                      <button onClick={() => syncPostConsultingWorkflowCeoOrder(selectedWorkflowDetail.workflow.id)} className="btn-primary text-sm py-2 px-4" data-testid="sync-post-consulting-ceo-order-button">
                        <Rocket className="w-4 h-4" /> Generar orden CEO
                      </button>
                    </div>
                  )}

                  <div className="grid gap-4 xl:grid-cols-[0.8fr_1.2fr]">
                    <div className="space-y-4">
                      <div className="rounded-[24px] border border-border-subtle bg-card/40 p-4" data-testid="post-consulting-detail-departments">
                        <p className="text-[10px] uppercase tracking-[0.18em] text-text-muted mb-2">Departamentos activados</p>
                        <div className="flex flex-wrap gap-2">{(selectedWorkflowDetail.workflow.department_rollup || []).map((item) => <span key={item} className="rounded-full border border-primary/20 bg-primary/10 px-2 py-1 text-[10px] uppercase tracking-[0.16em] text-primary">{item}</span>)}</div>
                      </div>
                      <div className="rounded-[24px] border border-border-subtle bg-card/40 p-4" data-testid="post-consulting-detail-collaboration-plan">
                        <p className="text-[10px] uppercase tracking-[0.18em] text-text-muted mb-2">Secuencia colaborativa</p>
                        <div className="space-y-3 text-sm text-text-body">
                          {(selectedWorkflowDetail.workflow.collaboration_plan || []).map((item) => (
                            <div key={item.agent_type} className="rounded-[18px] border border-border-subtle bg-background/55 p-3" data-testid={`post-consulting-collaboration-step-${item.agent_type}`}>
                              <p className="font-semibold text-text-heading">{item.agent_name}</p>
                              <p className="mt-1 text-xs text-text-muted">{item.department}</p>
                              <p className="mt-2">{item.mission}</p>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>

                    <div className="rounded-[24px] border border-border-subtle bg-card/40 p-4" data-testid="post-consulting-detail-report-markdown">
                      <p className="text-[10px] uppercase tracking-[0.18em] text-text-muted mb-3">Informe completo</p>
                      <div className="max-h-[520px] overflow-y-auto whitespace-pre-wrap text-sm text-text-body pr-2">
                        {selectedWorkflowDetail.workflow.report_markdown || 'El informe completo todavía no está listo.'}
                      </div>
                    </div>
                  </div>

                  <div className="grid gap-4 lg:grid-cols-2" data-testid="post-consulting-detail-agent-outputs">
                    {(selectedWorkflowDetail.workflow.agent_outputs || []).map((item) => (
                      <div key={item.agent_type} className="rounded-[24px] border border-border-subtle bg-card/40 p-4" data-testid={`post-consulting-detail-agent-${item.agent_type}`}>
                        <div className="flex items-start justify-between gap-3">
                          <div>
                            <p className="text-[10px] uppercase tracking-[0.18em] text-text-muted">{item.department}</p>
                            <h5 className="mt-2 text-lg font-semibold text-text-heading">{item.agent_name}</h5>
                          </div>
                          <span className="rounded-full border border-border-subtle px-2 py-1 text-[10px] uppercase tracking-[0.16em] text-text-muted">{item.status}</span>
                        </div>
                        <p className="mt-3 whitespace-pre-wrap text-sm text-text-body">{item.result || 'Sin resultado todavía.'}</p>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <div className="space-y-4">
                {serviceIntakes.map((intake) => (
                  <div key={intake.id} className="glass-card p-5" data-testid={`service-briefing-${intake.id}`}>
                    <div className="flex items-start justify-between gap-4 flex-wrap mb-3">
                      <div>
                        <h4 className="text-text-heading font-heading font-semibold text-lg">{intake.package_name}</h4>
                        <p className="text-text-muted text-sm mt-1">{intake.company_name} · {intake.contact_name} · {intake.contact_email}</p>
                      </div>
                      <div className="text-left md:text-right">
                        <span className={`text-xs px-2 py-1 rounded-full ${ROLE_COLORS[intake.pricing_role] || 'bg-primary/20 text-primary'}`}>{ROLE_LABELS[intake.pricing_role] || intake.pricing_role || 'Cliente'}</span>
                        <p className="text-text-muted text-xs mt-2">{new Date(intake.updated_at || intake.created_at).toLocaleString('es')}</p>
                      </div>
                    </div>
                    <div className="grid md:grid-cols-2 gap-4 text-sm">
                      <div className="bg-card rounded-xl p-4 border border-border-subtle">
                        <p className="text-text-muted text-xs uppercase tracking-wider mb-2">Objetivo</p>
                        <p className="text-text-body whitespace-pre-wrap">{intake.service_goal}</p>
                      </div>
                      <div className="bg-card rounded-xl p-4 border border-border-subtle">
                        <p className="text-text-muted text-xs uppercase tracking-wider mb-2">Negocio / contexto</p>
                        <p className="text-text-body whitespace-pre-wrap">{intake.business_description}</p>
                      </div>
                      <div className="bg-card rounded-xl p-4 border border-border-subtle">
                        <p className="text-text-muted text-xs uppercase tracking-wider mb-2">URLs</p>
                        <div className="space-y-1 text-text-body break-words">
                          {intake.website_url && <p>Web: {intake.website_url}</p>}
                          {intake.linkedin_url && <p>LinkedIn: {intake.linkedin_url}</p>}
                          {intake.instagram_url && <p>Instagram: {intake.instagram_url}</p>}
                          {intake.facebook_url && <p>Facebook: {intake.facebook_url}</p>}
                          {intake.youtube_url && <p>YouTube: {intake.youtube_url}</p>}
                          {intake.tiktok_url && <p>TikTok: {intake.tiktok_url}</p>}
                          {intake.other_urls && <p>Otros: {intake.other_urls}</p>}
                        </div>
                      </div>
                      <div className="bg-card rounded-xl p-4 border border-border-subtle">
                        <p className="text-text-muted text-xs uppercase tracking-wider mb-2">Herramientas / accesos</p>
                        <div className="space-y-2 text-text-body whitespace-pre-wrap">
                          {intake.current_tools && <p><span className="text-text-muted">Tools:</span> {intake.current_tools}</p>}
                          {intake.required_integrations && <p><span className="text-text-muted">Integraciones:</span> {intake.required_integrations}</p>}
                          {intake.api_access_notes && <p><span className="text-text-muted">Accesos/API:</span> {intake.api_access_notes}</p>}
                          {intake.assets_links && <p><span className="text-text-muted">Assets:</span> {intake.assets_links}</p>}
                          {intake.deadline && <p><span className="text-text-muted">Plazo:</span> {intake.deadline}</p>}
                          {intake.additional_notes && <p><span className="text-text-muted">Notas:</span> {intake.additional_notes}</p>}
                        </div>
                      </div>
                    </div>

                    {intake.automation_workflow && (
                      <div className="mt-4 rounded-2xl border border-primary/15 bg-primary/5 p-4" data-testid={`service-briefing-workflow-${intake.id}`}>
                        <div className="flex flex-wrap items-start justify-between gap-4">
                          <div>
                            <p className="text-text-muted text-xs uppercase tracking-wider">Workflow automático post-consultoría</p>
                            <h5 className="text-text-heading font-semibold mt-2">Estado · {intake.automation_workflow.status}</h5>
                            <p className="text-text-body text-sm mt-2">Task: {intake.automation_workflow.linked_task_id || 'sin task'} · Card: {intake.automation_workflow.linked_command_card_id || 'sin card'}</p>
                            {intake.automation_workflow.linked_task_status && <p className="text-text-muted text-xs mt-1">Task status: {intake.automation_workflow.linked_task_status}</p>}
                          </div>
                          <div className="flex flex-wrap gap-2">
                            <button
                              onClick={() => openPostConsultingWorkflowDetail(intake.automation_workflow.id)}
                              className="btn-primary text-sm py-2 px-4"
                              data-testid={`view-post-consulting-${intake.id}`}
                            >
                              <Eye className="w-4 h-4" /> Ver informe
                            </button>
                            <button
                              onClick={() => rerunPostConsultingWorkflow(intake.automation_workflow.id)}
                              className="btn-secondary text-sm py-2 px-4"
                              data-testid={`rerun-post-consulting-${intake.id}`}
                            >
                              <RefreshCw className="w-4 h-4" /> Reprocesar
                            </button>
                          </div>
                        </div>

                        <div className="mt-4 grid gap-4 md:grid-cols-2">
                          <div className="bg-card rounded-xl p-4 border border-border-subtle" data-testid={`service-briefing-focus-${intake.id}`}>
                            <p className="text-text-muted text-xs uppercase tracking-wider mb-2">Focos detectados</p>
                            <div className="flex flex-wrap gap-2">{(intake.automation_workflow.focus_areas || []).map((item) => <span key={item} className="rounded-full border border-primary/20 bg-primary/10 px-2 py-1 text-[10px] uppercase tracking-[0.16em] text-primary">{item}</span>)}</div>
                          </div>
                          <div className="bg-card rounded-xl p-4 border border-border-subtle" data-testid={`service-briefing-skills-${intake.id}`}>
                            <p className="text-text-muted text-xs uppercase tracking-wider mb-2">Skills sugeridas</p>
                            <div className="flex flex-wrap gap-2">{(intake.automation_workflow.recommended_skills || []).map((item) => <span key={item} className="rounded-full border border-border-subtle px-2 py-1 text-[10px] uppercase tracking-[0.16em] text-text-muted">{item}</span>)}</div>
                          </div>
                        </div>

                        <div className="mt-4 grid gap-4 md:grid-cols-2 text-sm">
                          <div className="bg-card rounded-xl p-4 border border-border-subtle" data-testid={`service-briefing-agents-${intake.id}`}>
                            <p className="text-text-muted text-xs uppercase tracking-wider mb-2">Agentes activados</p>
                            <div className="flex flex-wrap gap-2">{(intake.automation_workflow.selected_agents || []).map((item) => <span key={item} className="rounded-full border border-primary/20 bg-primary/10 px-2 py-1 text-[10px] uppercase tracking-[0.16em] text-primary">{item}</span>)}</div>
                          </div>
                          <div className="bg-card rounded-xl p-4 border border-border-subtle" data-testid={`service-briefing-departments-${intake.id}`}>
                            <p className="text-text-muted text-xs uppercase tracking-wider mb-2">Departamentos</p>
                            <div className="flex flex-wrap gap-2">{(intake.automation_workflow.department_rollup || []).map((item) => <span key={item} className="rounded-full border border-border-subtle px-2 py-1 text-[10px] uppercase tracking-[0.16em] text-text-muted">{item}</span>)}</div>
                          </div>
                        </div>

                        <div className="mt-4 grid gap-4 md:grid-cols-2 text-sm">
                          <div className="bg-card rounded-xl p-4 border border-border-subtle" data-testid={`service-briefing-next-actions-${intake.id}`}>
                            <p className="text-text-muted text-xs uppercase tracking-wider mb-2">Siguientes acciones</p>
                            <div className="space-y-2 text-text-body">{(intake.automation_workflow.next_actions || []).map((item, index) => <p key={item}><span className="text-primary mr-2">{index + 1}.</span>{item}</p>)}</div>
                          </div>
                          <div className="bg-card rounded-xl p-4 border border-border-subtle" data-testid={`service-briefing-report-${intake.id}`}>
                            <p className="text-text-muted text-xs uppercase tracking-wider mb-2">Resumen del informe</p>
                            <p className="text-text-body whitespace-pre-wrap">{intake.automation_workflow.executive_summary || intake.automation_workflow.report_excerpt || 'El informe se está preparando. Cuando termine, aquí aparecerá el resumen ejecutivo.'}</p>
                          </div>
                        </div>

                        {!!intake.automation_workflow.agent_outputs?.length && (
                          <div className="mt-4 grid gap-4 lg:grid-cols-2" data-testid={`service-briefing-agent-outputs-${intake.id}`}>
                            {intake.automation_workflow.agent_outputs.map((item) => (
                              <div key={item.agent_type} className="bg-card rounded-xl p-4 border border-border-subtle" data-testid={`service-briefing-agent-output-${intake.id}-${item.agent_type}`}>
                                <div className="flex items-start justify-between gap-3">
                                  <div>
                                    <p className="text-text-muted text-[10px] uppercase tracking-[0.16em]">{item.department}</p>
                                    <h6 className="mt-2 text-text-heading font-semibold">{item.agent_name}</h6>
                                  </div>
                                  <span className="rounded-full border border-border-subtle px-2 py-1 text-[10px] uppercase tracking-[0.16em] text-text-muted">{item.status}</span>
                                </div>
                                <p className="mt-3 text-sm text-text-body whitespace-pre-wrap">{item.excerpt || 'Aún sin salida visible.'}</p>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                ))}
                {serviceIntakes.length === 0 && (
                  <div className="glass-card p-10 text-center text-text-muted">
                    Aún no se han recibido briefings post-pago.
                  </div>
                )}
              </div>
            </div>
          )}

          {/* ===== SOCIAL PUBLISHING ===== */}
          {tab === 'publishing' && !selectedSocialOrder && (
            <div className="space-y-4" data-testid="admin-publishing">
              <div className="flex items-center justify-between gap-4 flex-wrap">
                <div>
                  <h3 className="text-text-heading font-heading text-lg font-semibold">Campañas y Publicaciones</h3>
                  <p className="text-text-muted text-sm mt-1">Instagram, Facebook y YouTube en modo borrador con aprobación. Las cuentas se conectarán después.</p>
                </div>
                <div className="flex items-center gap-2">
                  <button onClick={loadSocialOrders} className="p-2 rounded-lg bg-card border border-border-subtle text-text-muted hover:text-primary transition-all" title="Refrescar" data-testid="refresh-social-orders">
                    <RefreshCw className="w-4 h-4" />
                  </button>
                  <button onClick={() => setShowCreateSocialOrder(true)} className="btn-primary text-sm py-2 px-4" data-testid="create-social-order-btn">
                    <Plus className="w-4 h-4" /> Nueva Campaña
                  </button>
                </div>
              </div>

              <div className="glass-card p-5 grid md:grid-cols-3 gap-4">
                <div>
                  <p className="text-text-muted text-xs uppercase tracking-wider mb-1">Workflow actual</p>
                  <p className="text-text-heading font-medium">Agentes generan borradores, calendario, estrategia e ideas visuales.</p>
                </div>
                <div>
                  <p className="text-text-muted text-xs uppercase tracking-wider mb-1">Canales activos</p>
                  <p className="text-text-heading font-medium">Instagram · Facebook · YouTube</p>
                </div>
                <div>
                  <p className="text-text-muted text-xs uppercase tracking-wider mb-1">Publicación externa</p>
                  <p className="text-text-heading font-medium">Pendiente de conectar cuentas oficiales</p>
                </div>
              </div>

              <AnimatePresence>
                {showCreateSocialOrder && (
                  <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
                    className="fixed inset-0 z-[9999] bg-black/60 flex items-center justify-center p-4"
                    onClick={() => setShowCreateSocialOrder(false)}>
                    <motion.div initial={{ scale: 0.95 }} animate={{ scale: 1 }} exit={{ scale: 0.95 }}
                      className="glass-card p-6 w-full max-w-2xl max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-testid="create-social-order-modal">
                      <div className="flex items-center justify-between mb-4">
                        <h3 className="text-text-heading font-heading font-semibold text-lg">Nueva Orden Editorial</h3>
                        <button onClick={() => setShowCreateSocialOrder(false)} className="text-text-muted hover:text-white p-1"><X className="w-5 h-5" /></button>
                      </div>
                      <form onSubmit={createSocialOrder} className="space-y-4">
                        <div>
                          <label className="text-text-muted text-xs uppercase tracking-wider block mb-1">Nombre de campaña</label>
                          <input type="text" required value={newSocialOrder.campaign_name}
                            onChange={e => setNewSocialOrder({...newSocialOrder, campaign_name: e.target.value})}
                            className="input-kinesthetic" data-testid="social-order-campaign-name" />
                        </div>
                        <div>
                          <label className="text-text-muted text-xs uppercase tracking-wider block mb-1">Objetivo del negocio</label>
                          <textarea required rows={3} value={newSocialOrder.business_goal}
                            onChange={e => setNewSocialOrder({...newSocialOrder, business_goal: e.target.value})}
                            className="input-kinesthetic resize-none" data-testid="social-order-business-goal" />
                        </div>
                        <div className="grid md:grid-cols-2 gap-4">
                          <div>
                            <label className="text-text-muted text-xs uppercase tracking-wider block mb-1">Audiencia</label>
                            <textarea required rows={3} value={newSocialOrder.audience}
                              onChange={e => setNewSocialOrder({...newSocialOrder, audience: e.target.value})}
                              className="input-kinesthetic resize-none" data-testid="social-order-audience" />
                          </div>
                          <div>
                            <label className="text-text-muted text-xs uppercase tracking-wider block mb-1">Oferta / CTA comercial</label>
                            <textarea rows={3} value={newSocialOrder.offers}
                              onChange={e => setNewSocialOrder({...newSocialOrder, offers: e.target.value})}
                              className="input-kinesthetic resize-none" data-testid="social-order-offers" />
                          </div>
                        </div>
                        <div>
                          <label className="text-text-muted text-xs uppercase tracking-wider block mb-1">Tono de marca</label>
                          <input type="text" value={newSocialOrder.brand_voice}
                            onChange={e => setNewSocialOrder({...newSocialOrder, brand_voice: e.target.value})}
                            className="input-kinesthetic" data-testid="social-order-brand-voice" />
                        </div>
                        <div>
                          <label className="text-text-muted text-xs uppercase tracking-wider block mb-2">Canales</label>
                          <div className="flex flex-wrap gap-2">
                            {['instagram', 'facebook', 'youtube'].map(platform => (
                              <button key={platform} type="button" onClick={() => {
                                const current = newSocialOrder.platforms;
                                setNewSocialOrder({
                                  ...newSocialOrder,
                                  platforms: current.includes(platform) ? current.filter(p => p !== platform) : [...current, platform]
                                });
                              }} className={`px-3 py-2 rounded-lg text-sm font-medium transition-all ${
                                newSocialOrder.platforms.includes(platform)
                                  ? 'bg-primary/20 text-primary border border-primary/40'
                                  : 'bg-card border border-border-subtle text-text-muted hover:border-primary/30'
                              }`} data-testid={`social-platform-${platform}`}>
                                {platform}
                              </button>
                            ))}
                          </div>
                        </div>
                        <div className="grid grid-cols-2 gap-3">
                          <div>
                            <label className="text-text-muted text-xs uppercase tracking-wider block mb-1">Semanas</label>
                            <input type="number" min="1" max="12" value={newSocialOrder.weeks}
                              onChange={e => setNewSocialOrder({...newSocialOrder, weeks: Number(e.target.value)})}
                              className="input-kinesthetic" data-testid="social-order-weeks" />
                          </div>
                          <div>
                            <label className="text-text-muted text-xs uppercase tracking-wider block mb-1">Posts por semana</label>
                            <input type="number" min="1" max="14" value={newSocialOrder.posts_per_week}
                              onChange={e => setNewSocialOrder({...newSocialOrder, posts_per_week: Number(e.target.value)})}
                              className="input-kinesthetic" data-testid="social-order-posts-per-week" />
                          </div>
                        </div>
                        <div className="grid md:grid-cols-3 gap-3">
                          {[
                            ['include_strategy', 'Estrategia'],
                            ['include_calendar', 'Calendario'],
                            ['include_images', 'Prompts visuales']
                          ].map(([key, label]) => (
                            <label key={key} className="flex items-center gap-2 cursor-pointer text-sm text-text-body">
                              <input type="checkbox" checked={newSocialOrder[key]}
                                onChange={e => setNewSocialOrder({...newSocialOrder, [key]: e.target.checked})}
                                className="w-4 h-4 rounded border-border-subtle" />
                              <span>{label}</span>
                            </label>
                          ))}
                        </div>
                        <button type="submit" className="btn-primary w-full" data-testid="submit-social-order">
                          <Plus className="w-4 h-4" /> Crear campaña y activar agentes
                        </button>
                      </form>
                    </motion.div>
                  </motion.div>
                )}
              </AnimatePresence>

              <div className="grid lg:grid-cols-2 gap-4">
                {socialOrders.map(order => {
                  const statusCfg = SOCIAL_STATUS_CONFIG[order.status] || SOCIAL_STATUS_CONFIG.borrador;
                  const StatusIcon = statusCfg.icon;
                  return (
                    <motion.div key={order.id} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}
                      className="glass-card p-5 cursor-pointer hover:border-primary/40 transition-all"
                      onClick={() => loadSocialOrderDetail(order.id)} data-testid={`social-order-card-${order.id}`}>
                      <div className="flex items-start justify-between gap-3 mb-3">
                        <div>
                          <h4 className="text-text-heading font-heading font-semibold text-lg">{order.campaign_name}</h4>
                          <p className="text-text-muted text-sm mt-1 line-clamp-2">{order.business_goal}</p>
                        </div>
                        <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs ${statusCfg.color}`}>
                          <StatusIcon className={`w-3 h-3 ${order.status === 'en_proceso' ? 'animate-spin' : ''}`} /> {statusCfg.label}
                        </span>
                      </div>
                      <div className="flex flex-wrap gap-2 mb-3">
                        {order.platforms.map(platform => (
                          <span key={platform} className="px-2 py-1 rounded-full text-xs bg-card border border-border-subtle text-text-body">{platform}</span>
                        ))}
                        <span className={`px-2 py-1 rounded-full text-xs border ${APPROVAL_CONFIG[order.approval_status] || APPROVAL_CONFIG.pendiente}`}>
                          {order.approval_status}
                        </span>
                      </div>
                      <div className="grid grid-cols-2 gap-2 text-xs text-text-muted">
                        <span>{order.weeks} semanas</span>
                        <span>{order.posts_per_week} posts/semana</span>
                      </div>
                      <div className="mt-3 space-y-2">
                        <div className="flex items-center justify-between text-[11px] text-text-muted">
                          <span>{order.stage || 'sin etapa'}</span>
                          <span>{order.progress || 0}%</span>
                        </div>
                        <div className="h-2 rounded-full bg-card border border-border-subtle overflow-hidden" data-testid={`social-order-progress-${order.id}`}>
                          <div className="h-full bg-primary transition-all duration-500" style={{ width: `${order.progress || 0}%` }} />
                        </div>
                      </div>
                    </motion.div>
                  );
                })}
              </div>

              {socialOrders.length === 0 && (
                <div className="glass-card p-12 text-center">
                  <Bell className="w-10 h-10 text-text-muted mx-auto mb-4" />
                  <h3 className="text-text-heading font-heading font-semibold text-lg mb-2">Sin campañas todavía</h3>
                  <p className="text-text-muted mb-4">Crea una orden editorial y los agentes prepararán borradores, calendario y estrategia.</p>
                  <button onClick={() => setShowCreateSocialOrder(true)} className="btn-primary text-sm" data-testid="create-first-social-order">
                    <Plus className="w-4 h-4" /> Crear primera campaña
                  </button>
                </div>
              )}
            </div>
          )}

          {tab === 'publishing' && selectedSocialOrder && (
            <div className="space-y-4" data-testid="social-order-detail">
              <button onClick={() => setSelectedSocialOrder(null)} className="text-primary text-sm hover:underline flex items-center gap-1" data-testid="back-to-social-orders">
                <ChevronRight className="w-4 h-4 rotate-180" /> Volver a campañas
              </button>

              <div className="glass-card p-6">
                <div className="flex items-start justify-between gap-4 flex-wrap mb-4">
                  <div className="flex-1">
                    <div className="flex flex-wrap items-center gap-2 mb-2">
                      <span className={`text-xs px-2 py-0.5 rounded-full ${SOCIAL_STATUS_CONFIG[selectedSocialOrder.status]?.color || SOCIAL_STATUS_CONFIG.borrador.color}`}>
                        {SOCIAL_STATUS_CONFIG[selectedSocialOrder.status]?.label || selectedSocialOrder.status}
                      </span>
                      <span className={`text-xs px-2 py-0.5 rounded-full border ${APPROVAL_CONFIG[selectedSocialOrder.approval_status] || APPROVAL_CONFIG.pendiente}`}>
                        {selectedSocialOrder.approval_status}
                      </span>
                    </div>
                    <h2 className="text-text-heading font-heading font-bold text-xl mb-2">{selectedSocialOrder.campaign_name}</h2>
                    <p className="text-text-body text-base mb-2">{selectedSocialOrder.business_goal}</p>
                    <p className="text-text-muted text-sm">Audiencia: {selectedSocialOrder.audience}</p>
                  </div>
                  <div className="flex items-center gap-2">
                    <button onClick={() => loadSocialOrderDetail(selectedSocialOrder.id)} className="p-2 rounded-lg bg-card border border-border-subtle text-text-muted hover:text-primary transition-all" title="Refrescar detalle" data-testid="refresh-social-order-detail">
                      <RefreshCw className="w-4 h-4" />
                    </button>
                    <button onClick={() => retrySocialOrder(selectedSocialOrder.id)} className="p-2 rounded-lg bg-primary/10 text-primary hover:bg-primary/20 transition-all" title="Reintentar campaña" data-testid="retry-social-order">
                      <RefreshCw className="w-4 h-4" />
                    </button>
                    <button onClick={() => updateSocialOrderApproval(selectedSocialOrder.id, 'aprobado')} className="btn-primary text-sm py-2 px-4" data-testid="approve-social-order">
                      <CheckCircle2 className="w-4 h-4" /> Aprobar
                    </button>
                    <button onClick={() => updateSocialOrderApproval(selectedSocialOrder.id, 'rechazado')} className="btn-secondary text-sm py-2 px-4" data-testid="reject-social-order">
                      <X className="w-4 h-4" /> Rechazar
                    </button>
                  </div>
                </div>

                <div className="grid md:grid-cols-4 gap-3 text-sm">
                  <div className="bg-card rounded-xl p-3 border border-border-subtle"><p className="text-text-muted text-xs mb-1">Canales</p><p className="text-text-heading">{selectedSocialOrder.platforms.join(' · ')}</p></div>
                  <div className="bg-card rounded-xl p-3 border border-border-subtle"><p className="text-text-muted text-xs mb-1">Duración</p><p className="text-text-heading">{selectedSocialOrder.weeks} semanas</p></div>
                  <div className="bg-card rounded-xl p-3 border border-border-subtle"><p className="text-text-muted text-xs mb-1">Frecuencia</p><p className="text-text-heading">{selectedSocialOrder.posts_per_week} posts/semana</p></div>
                  <div className="bg-card rounded-xl p-3 border border-border-subtle"><p className="text-text-muted text-xs mb-1">Publicación</p><p className="text-text-heading">Pendiente conectar cuentas</p></div>
                </div>

                <div className="mt-4 grid lg:grid-cols-[1fr_0.8fr] gap-4">
                  <div className="bg-card rounded-xl p-4 border border-border-subtle">
                    <div className="flex items-center justify-between text-xs text-text-muted mb-2">
                      <span>Etapa actual: {selectedSocialOrder.stage || 'sin etapa'}</span>
                      <span>{selectedSocialOrder.progress || 0}%</span>
                    </div>
                    <div className="h-3 rounded-full bg-[#0A1A3F] overflow-hidden border border-border-subtle" data-testid="social-order-detail-progress">
                      <div className="h-full bg-primary transition-all duration-500" style={{ width: `${selectedSocialOrder.progress || 0}%` }} />
                    </div>
                    {selectedSocialOrder.last_error && (
                      <p className="text-yellow-400 text-xs mt-3">{selectedSocialOrder.last_error}</p>
                    )}
                  </div>
                  <div className="bg-card rounded-xl p-4 border border-border-subtle" data-testid="social-order-quality-report">
                    <p className="text-text-muted text-xs uppercase tracking-wider mb-2">Calidad automática</p>
                    <div className="flex items-center justify-between mb-2">
                      <span className="text-text-heading font-medium">Score</span>
                      <span className="text-primary font-bold">{selectedSocialOrder.quality_report?.score || 0}%</span>
                    </div>
                    <p className="text-text-muted text-sm">Agentes completos: {selectedSocialOrder.quality_report?.completed_agents || 0}/{selectedSocialOrder.quality_report?.total_agents || 3}</p>
                    <p className="text-text-muted text-sm mt-1">Plan final: {selectedSocialOrder.quality_report?.has_final_plan ? 'Sí' : 'No'}</p>
                    {!!selectedSocialOrder.quality_report?.missing_items?.length && (
                      <p className="text-yellow-400 text-xs mt-2">Pendiente: {selectedSocialOrder.quality_report.missing_items.join(', ')}</p>
                    )}
                  </div>
                </div>
              </div>

              <div className="glass-card p-6">
                <h3 className="text-text-heading font-heading font-semibold text-lg mb-3">Plan Final para Aprobación</h3>
                {selectedSocialOrder.final_plan ? (
                  <div className="bg-[#0A1A3F] border border-border-subtle rounded-xl p-4 text-text-body text-sm leading-relaxed whitespace-pre-wrap max-h-[520px] overflow-y-auto" data-testid="social-order-final-plan">
                    {selectedSocialOrder.final_plan}
                  </div>
                ) : (
                  <div className="bg-card rounded-xl p-4 text-text-muted text-sm flex items-center gap-2">
                    <Loader2 className="w-4 h-4 animate-spin" /> El plan final todavía se está preparando.
                  </div>
                )}
              </div>

              <div className="glass-card p-6">
                <h3 className="text-text-heading font-heading font-semibold text-lg mb-4">Timeline de Ejecución</h3>
                <div className="space-y-3" data-testid="social-order-timeline">
                  {(selectedSocialOrder.timeline || []).slice().reverse().map(event => (
                    <div key={event.id} className="bg-card border border-border-subtle rounded-xl p-4">
                      <div className="flex items-center justify-between gap-3">
                        <p className="text-text-heading text-sm font-medium">{event.message}</p>
                        <span className={`text-[10px] px-2 py-1 rounded-full ${
                          event.level === 'error' ? 'bg-red-500/20 text-red-400' :
                          event.level === 'warning' ? 'bg-yellow-500/20 text-yellow-400' :
                          event.level === 'success' ? 'bg-green-500/20 text-green-400' :
                          'bg-primary/20 text-primary'
                        }`}>{event.event_type}</span>
                      </div>
                      <div className="flex items-center justify-between gap-3 mt-2 text-xs text-text-muted">
                        <span>{new Date(event.timestamp).toLocaleString('es')}</span>
                        <span>{event.progress ?? 0}%</span>
                      </div>
                    </div>
                  ))}
                  {(!selectedSocialOrder.timeline || selectedSocialOrder.timeline.length === 0) && (
                    <p className="text-text-muted text-sm">Todavía no hay eventos registrados.</p>
                  )}
                </div>
              </div>

              <div className="space-y-4">
                {['CONTENIDO', 'VENTAS', 'COMERCIAL'].map(agentType => {
                  const result = selectedSocialOrder.agent_outputs?.[agentType];
                  const AgIcon = AGENT_ICONS[agentType] || Sparkles;
                  return (
                    <div key={agentType} className="glass-card p-5">
                      <div className="flex items-center gap-3 mb-3">
                        <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${result?.status === 'completado' ? 'bg-green-500/15' : result?.status === 'error' ? 'bg-red-500/15' : 'bg-primary/15'}`}>
                          <AgIcon className={`w-5 h-5 ${result?.status === 'completado' ? 'text-green-400' : result?.status === 'error' ? 'text-red-400' : 'text-primary'}`} />
                        </div>
                        <div>
                          <p className="text-text-heading font-heading font-semibold text-base">{agentType}</p>
                          <p className="text-text-muted text-xs">{result?.status || 'esperando'}</p>
                        </div>
                      </div>
                      {result?.result ? (
                        <div className="bg-[#0A1A3F] border border-border-subtle rounded-xl p-4 text-text-body text-sm leading-relaxed whitespace-pre-wrap max-h-[320px] overflow-y-auto" data-testid={`social-agent-output-${agentType.toLowerCase()}`}>
                          {result.result}
                        </div>
                      ) : (
                        <div className="bg-card rounded-xl p-4 text-text-muted text-sm flex items-center gap-2">
                          <Loader2 className="w-4 h-4 animate-spin" /> El agente está trabajando en esta parte...
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* ===== TASKS (TRELLO BOARD) ===== */}
          {tab === 'tasks' && !selectedTask && (
            <div className="space-y-4" data-testid="admin-tasks">
              <div className="flex items-center justify-between">
                <h3 className="text-text-heading font-heading text-lg font-semibold">Órdenes a Agentes</h3>
                <div className="flex items-center gap-2">
                  <button onClick={loadTasks} className="p-2 rounded-lg bg-card border border-border-subtle text-text-muted hover:text-primary transition-all" title="Refrescar">
                    <RefreshCw className="w-4 h-4" />
                  </button>
                  <button onClick={() => setShowCreateTask(true)} className="btn-primary text-sm py-2 px-4" data-testid="create-task-btn">
                    <Plus className="w-4 h-4" /> Nueva Orden
                  </button>
                </div>
              </div>

              {/* Status filters */}
              <div className="flex gap-2 flex-wrap">
                {[{ id: 'all', label: 'Todas' }, ...Object.entries(STATUS_CONFIG).map(([id, c]) => ({ id, label: c.label }))].map(f => (
                  <button key={f.id} onClick={() => setTaskFilter(f.id)}
                    className={`px-3 py-1.5 rounded-full text-sm font-medium transition-all ${
                      taskFilter === f.id ? 'bg-primary text-[#0A1A3F]' : 'bg-card border border-border-subtle text-text-muted hover:border-primary/40'
                    }`}>{f.label}</button>
                ))}
              </div>

              {/* Create task modal */}
              <AnimatePresence>
                {showCreateTask && (
                  <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
                    className="fixed inset-0 z-[9999] bg-black/60 flex items-center justify-center p-4"
                    onClick={() => setShowCreateTask(false)}>
                    <motion.div initial={{ scale: 0.95 }} animate={{ scale: 1 }} exit={{ scale: 0.95 }}
                      className="glass-card p-6 w-full max-w-lg max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-testid="create-task-modal">
                      <div className="flex items-center justify-between mb-4">
                        <h3 className="text-text-heading font-heading font-semibold text-lg">Nueva Orden</h3>
                        <button onClick={() => setShowCreateTask(false)} className="text-text-muted hover:text-white p-1"><X className="w-5 h-5" /></button>
                      </div>
                      <form onSubmit={createTask} className="space-y-4">
                        <div>
                          <label className="text-text-muted text-xs uppercase tracking-wider block mb-1">Título</label>
                          <input type="text" placeholder="Ej: Generar propuesta comercial sector restaurantes" required
                            value={newTask.title} onChange={e => setNewTask({...newTask, title: e.target.value})}
                            className="input-kinesthetic" data-testid="task-title" />
                        </div>
                        <div>
                          <label className="text-text-muted text-xs uppercase tracking-wider block mb-1">Descripción detallada</label>
                          <textarea placeholder="Describe exactamente lo que necesitas que hagan los agentes..."
                            required rows={4} value={newTask.description}
                            onChange={e => setNewTask({...newTask, description: e.target.value})}
                            className="input-kinesthetic resize-none" data-testid="task-description" />
                        </div>
                        <div>
                          <label className="text-text-muted text-xs uppercase tracking-wider block mb-2">Asignar agentes</label>
                          <div className="flex flex-wrap gap-2">
                            {Object.entries(AGENT_ICONS).map(([type, Icon]) => (
                              <button key={type} type="button"
                                onClick={() => {
                                  const cur = newTask.assigned_agents;
                                  setNewTask({...newTask, assigned_agents: cur.includes(type) ? cur.filter(x => x !== type) : [...cur, type]});
                                }}
                                className={`flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium transition-all ${
                                  newTask.assigned_agents.includes(type)
                                    ? 'bg-primary/20 text-primary border border-primary/40'
                                    : 'bg-card border border-border-subtle text-text-muted hover:border-primary/30'
                                }`}>
                                <Icon className="w-4 h-4" /> {type}
                              </button>
                            ))}
                          </div>
                        </div>
                        <div className="grid grid-cols-2 gap-3">
                          <div>
                            <label className="text-text-muted text-xs uppercase tracking-wider block mb-1">Prioridad</label>
                            <select value={newTask.priority} onChange={e => setNewTask({...newTask, priority: e.target.value})}
                              className="input-kinesthetic">
                              <option value="baja">Baja</option>
                              <option value="media">Media</option>
                              <option value="alta">Alta</option>
                              <option value="urgente">Urgente</option>
                            </select>
                          </div>
                          <div>
                            <label className="text-text-muted text-xs uppercase tracking-wider block mb-1">Fecha límite</label>
                            <input type="date" value={newTask.deadline}
                              onChange={e => setNewTask({...newTask, deadline: e.target.value})}
                              className="input-kinesthetic" />
                          </div>
                        </div>
                        <label className="flex items-center gap-2 cursor-pointer">
                          <input type="checkbox" checked={newTask.auto_execute}
                            onChange={e => setNewTask({...newTask, auto_execute: e.target.checked})}
                            className="w-4 h-4 rounded border-border-subtle" />
                          <span className="text-text-body text-sm">Ejecutar automáticamente con IA</span>
                        </label>
                        <button type="submit" className="btn-primary w-full" data-testid="submit-task">
                          <Plus className="w-4 h-4" /> Crear y Ejecutar
                        </button>
                      </form>
                    </motion.div>
                  </motion.div>
                )}
              </AnimatePresence>

              {/* Trello-style board */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                {Object.entries(STATUS_CONFIG).map(([status, cfg]) => {
                  const StatusIcon = cfg.icon;
                  const filteredTasks = tasks.filter(t =>
                    t.status === status && (taskFilter === 'all' || taskFilter === status)
                  );
                  if (taskFilter !== 'all' && taskFilter !== status) return null;
                  return (
                    <div key={status} className="space-y-3">
                      <div className="flex items-center gap-2 px-1">
                        <StatusIcon className={`w-4 h-4 ${cfg.color.split(' ')[1]}`} />
                        <span className="text-text-heading font-heading font-semibold text-sm">{cfg.label}</span>
                        <span className="text-text-muted text-xs ml-auto">{filteredTasks.length}</span>
                      </div>
                      <div className="space-y-2 min-h-[100px]">
                        {filteredTasks.map(task => {
                          const pri = PRIORITY_CONFIG[task.priority] || PRIORITY_CONFIG.media;
                          return (
                            <motion.div key={task.id} initial={{ opacity: 0, y: 5 }} animate={{ opacity: 1, y: 0 }}
                              className="glass-card p-4 cursor-pointer hover:border-primary/40 transition-all"
                              onClick={() => loadTaskDetail(task.id)} data-testid={`task-card-${task.id}`}>
                              <div className="flex items-start justify-between mb-2">
                                <span className={`text-[10px] px-2 py-0.5 rounded-full border ${pri.color}`}>{pri.label}</span>
                                {task.deadline && <span className="text-text-muted text-[10px]">{task.deadline}</span>}
                              </div>
                              <h4 className="text-text-heading text-sm font-medium mb-2 line-clamp-2">{task.title}</h4>
                              <div className="flex flex-wrap gap-1">
                                {task.assigned_agents.map(a => {
                                  const AgIcon = AGENT_ICONS[a] || Sparkles;
                                  const hasResult = task.results?.[a];
                                  return (
                                    <span key={a} className={`flex items-center gap-1 text-[10px] px-1.5 py-0.5 rounded ${
                                      hasResult?.status === 'completado' ? 'bg-green-500/15 text-green-400' :
                                      hasResult?.status === 'error' ? 'bg-red-500/15 text-red-400' : 'bg-card text-text-muted'
                                    }`}>
                                      <AgIcon className="w-3 h-3" /> {a}
                                    </span>
                                  );
                                })}
                              </div>
                            </motion.div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              </div>

              {tasks.length === 0 && (
                <div className="glass-card p-12 text-center">
                  <ClipboardList className="w-10 h-10 text-text-muted mx-auto mb-4" />
                  <h3 className="text-text-heading font-heading font-semibold text-lg mb-2">Sin tareas todavía</h3>
                  <p className="text-text-muted mb-4">Crea tu primera orden y los agentes trabajarán automáticamente</p>
                  <button onClick={() => setShowCreateTask(true)} className="btn-primary text-sm">
                    <Plus className="w-4 h-4" /> Crear Primera Orden
                  </button>
                </div>
              )}
            </div>
          )}

          {/* Task Detail View */}
          {tab === 'tasks' && selectedTask && (
            <div className="space-y-4" data-testid="task-detail">
              <button onClick={() => setSelectedTask(null)} className="text-primary text-sm hover:underline flex items-center gap-1">
                <ChevronRight className="w-4 h-4 rotate-180" /> Volver a tareas
              </button>

              <div className="glass-card p-6">
                <div className="flex items-start justify-between mb-4">
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-2">
                      <span className={`text-xs px-2 py-0.5 rounded-full ${STATUS_CONFIG[selectedTask.status]?.color}`}>
                        {STATUS_CONFIG[selectedTask.status]?.label}
                      </span>
                      <span className={`text-xs px-2 py-0.5 rounded-full border ${PRIORITY_CONFIG[selectedTask.priority]?.color}`}>
                        {PRIORITY_CONFIG[selectedTask.priority]?.label}
                      </span>
                      {selectedTask.deadline && (
                        <span className="text-text-muted text-xs flex items-center gap-1"><Clock className="w-3 h-3" />{selectedTask.deadline}</span>
                      )}
                    </div>
                    <h2 className="text-text-heading font-heading font-bold text-xl mb-2">{selectedTask.title}</h2>
                    <p className="text-text-body text-base">{selectedTask.description}</p>
                  </div>
                  <div className="flex items-center gap-2 ml-4">
                    <button onClick={() => retryTask(selectedTask.id)} className="p-2 rounded-lg bg-primary/10 text-primary hover:bg-primary/20 transition-all" title="Re-ejecutar">
                      <RefreshCw className="w-4 h-4" />
                    </button>
                    <button onClick={() => deleteTask(selectedTask.id)} className="p-2 rounded-lg bg-red-500/10 text-red-400 hover:bg-red-500/20 transition-all" title="Eliminar">
                      <Trash2 className="w-4 h-4" />
                    </button>
                  </div>
                </div>

                {/* Status change buttons */}
                <div className="flex gap-2 pt-4 border-t border-border-subtle">
                  <span className="text-text-muted text-sm self-center mr-2">Mover a:</span>
                  {Object.entries(STATUS_CONFIG).filter(([s]) => s !== selectedTask.status).map(([s, cfg]) => {
                    const SIcon = cfg.icon;
                    return (
                      <button key={s} onClick={() => updateTaskStatus(selectedTask.id, s)}
                        className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium transition-all ${cfg.color} hover:opacity-80`}>
                        <SIcon className="w-3 h-3" /> {cfg.label}
                      </button>
                    );
                  })}
                </div>
              </div>

              {/* Agent Results */}
              <h3 className="text-text-heading font-heading font-semibold text-lg">Resultados por Agente</h3>
              <div className="space-y-4">
                {selectedTask.assigned_agents.map(agentType => {
                  const AgIcon = AGENT_ICONS[agentType] || Sparkles;
                  const result = selectedTask.results?.[agentType];
                  return (
                    <motion.div key={agentType} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}
                      className="glass-card p-5">
                      <div className="flex items-center gap-3 mb-3">
                        <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${
                          result?.status === 'completado' ? 'bg-green-500/15' :
                          result?.status === 'error' ? 'bg-red-500/15' : 'bg-primary/15'
                        }`}>
                          <AgIcon className={`w-5 h-5 ${
                            result?.status === 'completado' ? 'text-green-400' :
                            result?.status === 'error' ? 'text-red-400' : 'text-primary'
                          }`} />
                        </div>
                        <div>
                          <p className="text-text-heading font-heading font-semibold text-base">{agentType}</p>
                          <p className="text-text-muted text-xs">
                            {result?.status === 'completado' ? `Completado · ${result.completed_at?.slice(0, 16)}` :
                             result?.status === 'error' ? 'Error al ejecutar' : 'Esperando...'}
                          </p>
                        </div>
                        {!result && (
                          <Loader2 className="w-5 h-5 text-primary animate-spin ml-auto" />
                        )}
                      </div>
                      {result?.result && (
                        <div className="bg-[#0A1A3F] border border-border-subtle rounded-xl p-4 text-text-body text-sm leading-relaxed whitespace-pre-wrap max-h-[400px] overflow-y-auto">
                          {result.result}
                        </div>
                      )}
                      {!result && (
                        <div className="bg-card rounded-xl p-4 text-text-muted text-sm flex items-center gap-2">
                          <Loader2 className="w-4 h-4 animate-spin" /> El agente está procesando la tarea...
                        </div>
                      )}
                    </motion.div>
                  );
                })}
              </div>
            </div>
          )}

          {/* ===== ACADEMY ADMIN HUB ===== */}
          {tab === 'academy' && <AcademyAdminHub />}

        </div>
      </div>

    {/* Aynara Command Bar — flotante fijo, siempre visible */}
    <AynaraCommandBar onNavigate={goToAdminTab} />
    </>
  );
}

// ── Academy Admin Hub (embedded in Admin Dashboard) ─────────────────────────
function AcademyAdminHub() {
  const { authFetch } = useAuth();
  const [stats, setStats] = useState(null);
  const [courses, setCourses] = useState([]);
  const [alerts, setAlerts] = useState([]);
  const [cohortes, setCohortes] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
    Promise.all([
      authFetch(`${API}/academy/admin/stats`).then(r => r.json()),
      authFetch(`${API}/academy/admin/courses`).then(r => r.json()),
      authFetch(`${API}/academy/alerts`).then(r => r.json()).catch(() => ({ alerts: [] })),
      authFetch(`${API}/academy/admin/cohortes`).then(r => r.json()).catch(() => ({ cohortes: [] })),
    ]).then(([s, c, a, co]) => {
      setStats(s);
      setCourses(c.courses || []);
      setAlerts(a.alerts || []);
      setCohortes(co.cohortes || []);
    });
  }, [authFetch]);

  const LINE_COLORS = {
    kids: 'bg-purple-500/20 text-purple-400',
    teens: 'bg-blue-500/20 text-blue-400',
    adultos: 'bg-emerald-500/20 text-emerald-400',
    profesionales: 'bg-amber-500/20 text-amber-400',
    social: 'bg-rose-500/20 text-rose-400',
    mediadores: 'bg-violet-500/20 text-violet-400',
  };

  return (
    <div className="space-y-6" data-testid="admin-academy-hub">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-2xl bg-indigo-600/20 border border-indigo-500/30 flex items-center justify-center">
            <BookOpen className="w-5 h-5 text-indigo-400" />
          </div>
          <div>
            <h2 className="text-text-heading font-heading font-bold text-xl">Neuralia369 Academy</h2>
            <p className="text-text-muted text-sm">Panel de gestión · WACA Alliance</p>
          </div>
        </div>
        <button onClick={() => navigate('/academy/admin')}
          className="flex items-center gap-2 px-4 py-2 rounded-xl bg-indigo-600 hover:bg-indigo-500 text-white text-sm font-bold transition"
          data-testid="go-to-academy-admin-btn">
          Panel Completo <ChevronRight className="w-4 h-4" />
        </button>
      </div>

      {/* Stats grid */}
      {stats ? (
        <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
          {[
            { label: 'Cursos publicados', value: stats.total_courses, icon: BookOpen, color: 'text-indigo-400', bg: 'bg-indigo-500/10' },
            { label: 'Inscripciones', value: stats.total_enrollments, icon: Users, color: 'text-emerald-400', bg: 'bg-emerald-500/10' },
            { label: 'Certificados', value: stats.total_certificates, icon: Award, color: 'text-amber-400', bg: 'bg-amber-500/10' },
            { label: 'Cohortes activas', value: stats.total_cohortes, icon: Building2, color: 'text-blue-400', bg: 'bg-blue-500/10' },
            { label: 'Alertas pendientes', value: stats.pending_alerts, icon: AlertCircle, color: stats.pending_alerts > 0 ? 'text-red-400' : 'text-text-muted', bg: stats.pending_alerts > 0 ? 'bg-red-500/10' : 'bg-card' },
          ].map(card => (
            <div key={card.label} className={`glass-card p-4 text-center ${card.bg} border border-border-subtle rounded-2xl`}>
              <card.icon className={`w-5 h-5 ${card.color} mx-auto mb-2`} />
              <p className={`text-3xl font-black ${card.color}`}>{card.value}</p>
              <p className="text-text-muted text-[10px] mt-1">{card.label}</p>
            </div>
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
          {[...Array(5)].map((_, i) => <div key={i} className="glass-card p-4 h-24 rounded-2xl animate-pulse bg-card" />)}
        </div>
      )}

      {/* Two-column: courses + alerts */}
      <div className="grid md:grid-cols-2 gap-5">
        {/* Courses with WACA stats */}
        <div className="glass-card p-5 space-y-4">
          <div className="flex items-center justify-between">
            <h3 className="text-text-heading font-heading font-semibold">Cursos & Certificación WACA</h3>
            <button onClick={() => navigate('/academy/admin')} className="text-xs text-primary hover:underline">Ver todos</button>
          </div>
          <div className="space-y-2 max-h-64 overflow-y-auto">
            {courses.slice(0, 8).map(c => (
              <div key={c.id} className="flex items-center gap-3 py-2 border-b border-border-subtle last:border-0">
                <span className={`text-[10px] font-bold px-2 py-0.5 rounded-lg ${LINE_COLORS[c.line] || 'bg-card text-text-muted'}`}>{c.code}</span>
                <div className="flex-1 min-w-0">
                  <p className="text-text-heading text-xs font-medium truncate">{c.name}</p>
                  <p className="text-text-muted text-[10px]">{c.total_enrollments} inscritos · {c.total_certificates} certs</p>
                </div>
                <div className="text-right flex-shrink-0">
                  <p className="text-text-heading text-xs font-bold">${c.price_usd}</p>
                  <span className={`text-[9px] px-1.5 py-0.5 rounded-full ${c.status === 'published' ? 'bg-emerald-500/20 text-emerald-400' : 'bg-yellow-500/20 text-yellow-400'}`}>{c.status}</span>
                </div>
              </div>
            ))}
          </div>
          {/* WACA certification note */}
          <div className="bg-amber-500/10 border border-amber-500/20 rounded-xl p-3 text-xs text-amber-300">
            <p className="font-bold mb-0.5">Certificación WACA</p>
            <p className="text-amber-300/80">Los temas completados (tests ≥70%) generan certificados PDF válidos para presentar a WACA. La acreditación final requiere firma del MOU complementario.</p>
          </div>
        </div>

        {/* Cohortes + Alerts */}
        <div className="space-y-4">
          {/* Cohortes */}
          <div className="glass-card p-5 space-y-3">
            <div className="flex items-center justify-between">
              <h3 className="text-text-heading font-heading font-semibold text-sm">Cohortes Activas</h3>
              <span className="text-[10px] bg-blue-500/20 text-blue-400 px-2 py-0.5 rounded-full">{cohortes.filter(c => c.status === 'active').length} activas</span>
            </div>
            {cohortes.length === 0 ? (
              <p className="text-text-muted text-xs py-2">Sin cohortes aún. Crea una desde el panel completo.</p>
            ) : cohortes.slice(0, 4).map(c => (
              <div key={c.id} className="flex items-center justify-between">
                <div>
                  <p className="text-text-heading text-xs font-medium">{c.name}</p>
                  <p className="text-text-muted text-[10px]">{c.organization}</p>
                </div>
                <div className="text-right">
                  <p className="text-text-heading text-xs font-bold">{c.current_participants}/{c.max_participants}</p>
                  <span className={`text-[9px] px-1.5 py-0.5 rounded-full ${c.status === 'active' ? 'bg-emerald-500/20 text-emerald-400' : 'bg-yellow-500/20 text-yellow-400'}`}>{c.status}</span>
                </div>
              </div>
            ))}
          </div>

          {/* Pending Alerts */}
          <div className="glass-card p-5 space-y-3">
            <div className="flex items-center justify-between">
              <h3 className="text-text-heading font-heading font-semibold text-sm">Alertas de Protección</h3>
              {alerts.length > 0 && (
                <span className="text-[10px] bg-red-500/20 text-red-400 px-2 py-0.5 rounded-full animate-pulse">{alerts.length} pendiente{alerts.length > 1 ? 's' : ''}</span>
              )}
            </div>
            {alerts.length === 0 ? (
              <div className="flex items-center gap-2 text-emerald-400 text-xs py-2">
                <CheckCircle2 className="w-4 h-4" /> Sin alertas pendientes
              </div>
            ) : alerts.slice(0, 3).map(a => (
              <div key={a.id} className={`text-xs px-3 py-2 rounded-xl border ${a.type === 'diary_risk' ? 'border-red-500/30 bg-red-500/10 text-red-300' : 'border-amber-500/30 bg-amber-500/10 text-amber-300'}`}>
                <p className="font-semibold">{a.type === 'diary_risk' ? 'Alerta diario — revisión urgente' : 'Botón ayuda pulsado'}</p>
                <p className="text-[10px] opacity-80 mt-0.5">{a.created_at?.slice(0,16).replace('T',' ')}</p>
              </div>
            ))}
            {alerts.length > 0 && (
              <button onClick={() => navigate('/academy/admin')} className="text-xs text-red-400 hover:underline">Gestionar alertas →</button>
            )}
          </div>
        </div>
      </div>

      {/* Quick links */}
      <div className="glass-card p-5">
        <h3 className="text-text-heading font-heading font-semibold text-sm mb-4">Accesos Rápidos</h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {[
            { label: 'Panel completo Academy', to: '/academy/admin', icon: GraduationCap, color: 'text-indigo-400' },
            { label: 'Catálogo público', to: '/academy', icon: BookOpen, color: 'text-emerald-400' },
            { label: 'Dashboard alumno', to: '/academy/mi-perfil', icon: Users, color: 'text-blue-400' },
            { label: 'Login Academy', to: '/acceso-academy', icon: Shield, color: 'text-amber-400' },
          ].map(link => (
            <button key={link.to} onClick={() => navigate(link.to)}
              className="flex items-center gap-2.5 px-4 py-3 rounded-xl bg-card hover:bg-card/80 border border-border-subtle hover:border-primary/30 text-left transition text-xs">
              <link.icon className={`w-4 h-4 ${link.color} flex-shrink-0`} />
              <span className="text-text-muted">{link.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
